import React, { useState, useEffect, useRef } from "react";
import { FieldLabel, DropZone } from "@measured/puck";
import axios from "axios";
import { toast } from "react-toastify";
import Svg from "../../../../component/Svg";
import { Link } from 'react-router-dom';
import Logo from '../images/tata-com.svg';
import Logo1 from '../images/tata-com.svg';
import Logo2 from '../images/tata.svg';
import Logo3 from '../images/kaleyra.svg';
import LogoWhite from '../images/logo-white.svg';
import LogoThankYou from '../images/logo-thank-you.svg';
import BgImage from '../images/bg-image.png';
import ReactEcharts from "echarts-for-react";
import bannerImageLaptop from '../images/banner-image.png'
import DateField from "./DateField";
import Range from "./Range";
import CardIcon from '../images/lower-cost.png'
import icon from '../images/roi-download.png'
import icon2 from '../images/icon.svg'
import { v4 as uuidv4 } from 'uuid';
import pucksettings from "../../../PuckEditorSettings";
import { Alignment } from "@blueprintjs/core";
import { performHttpRequest } from '../../../../../axios/PerformHttpRequest';
import buttonIconSVG from '../images/button-icon.svg'
import { uniqueId } from "@blueprintjs/core/lib/esm/common/utils";
import { resolveMediaUrl } from "../../../../common/mediaUrl";

const apiUrl = process.env.REACT_APP_NODE_API_URL;

const OneYearChartOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    series: [
        {
            name: 'Actual Benefits with Vodafone',
            type: 'pie',
            radius: '50%',
            color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
            data: [
                { value: 1048, name: 'Lower Costs' },
                { value: 735, name: 'Increase Productivity' },
                { value: 580, name: 'Enable Business' },

            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};

const ThreeYearChartOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '0%',
        top: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2022', '2023', '2024']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [

        {
            name: 'Lower Costs',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#9C2AA0' // Apply purple color here
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: 'Increase Productivity',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#EB9700' // Apply orange color here
            },
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: 'Enable Business',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#00B0CA' // Apply cyan color here
            },
            data: [150, 232, 201, 154, 190, 330, 410]
        },
    ]
};


const PieChartOptions = {
    tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)' // Shows name, value, and percentage
    },
    legend: {
        orient: 'horizontal',
        left: 'center',
        bottom: '0', // Adjust as needed for vertical position
        data: ['Premium', 'Standard', 'Basic'], // Matches the names in series.data
        itemGap: 50, // Space between legend items
        itemWidth: 15,  // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
        itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)

    },
    // title is used for the text in the center of the donut
    title: {
        text: 'Total Licenses', // The main number
        subtext: '450', // The text below the number
        left: 'center',
        top: '42%', // Position in the middle of the chart

        textStyle: {
            fontSize: 14, // Adjust font size for "Total Licenses"
            fontWeight: 'normal',
            color: '#666' // Adjust color as needed
        },
        subtextStyle: {
            fontSize: 36, // Adjust font size for "450"
            fontWeight: 'bold',
            color: '#333' // Adjust color as needed
        },

    },
    series: [
        {
            name: 'Licenses', // A name for the series, appears in tooltips
            type: 'pie',
            // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
            // Adjust these percentages for the desired thickness of the donut
            radius: ['40%', '75%'],
            center: ['50%', '50%'], // Ensure chart is centered if title is also centered
            avoidLabelOverlap: false, // Important for custom label positioning
            color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Purple, Orange, Teal
            data: [
                { value: 0, name: 'Premium' }, // Corresponds to #9C2AA0 (Purple)
                { value: 0, name: 'Standard' },// Corresponds to #EB9700 (Orange)
                { value: 0, name: 'Basic' }    // Corresponds to #00B0CA (Teal)
            ],
            label: {
                show: true,
                position: 'outside',
                formatter: '{c}', // Show the value (count) on the label
                color: '#333', // Label text color
                fontSize: 12,
                // distanceToLabelLine: 5, // Optional: adjust space between label and line start
            },
            labelLine: {
                show: true,
                length: 15,  // Length of the first part of the line
                length2: 10, // Length of the second part of the line (after the jog)
                smooth: false // Use straight lines
            },
            emphasis: { // Style when hovering over a slice
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.3)'
                },
                label: { // Optional: make label more prominent on hover
                    show: true,
                    fontSize: '14',
                    fontWeight: 'bold'
                }
            },
            // The `top` property from your original series is removed as `center` and `title` positioning handles it.
        }
    ],
    // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
    // You can remove it if you prefer.
    grid: {
        left: '5%',   // Adjusted to give more space if labels are long
        right: '5%',
        bottom: '15%', // Ensure space for the legend
        containLabel: true
    },
};

const BarChartOptions = {
    tooltip: {

        axisPointer: {
            type: 'shadow'
        }
        // The default tooltip formatter for 'axis' trigger will list all series.
    },
    legend: {
        show: true,
        data: ['Remote Workers', 'Office Workers', 'On the Road Workers', 'Hybrid Workers'], // Derived from series names
        bottom: '0', // Or '5%' or adjust as needed
        left: 'center',
        itemGap: 15,
        itemWidth: 12,
        itemHeight: 12,
        icon: 'circle', // Make all legend icons circles
        textStyle: {
            color: '#595959', // Matching image text color
            fontSize: 13
        }
    },
    grid: {
        left: '3%',   // Adjust if y-axis labels need more or less space
        top: '5%',  // Space from the top
        right: '4%', // Space from the right
        bottom: '35%', // Ample space for the legend below the x-axis area
        containLabel: true // Ensures labels (like y-axis) fit
    },
    xAxis: [
        {
            type: 'category',
            // Using an empty string or a non-displaying character for a single grouping point
            // if you don't want any visible x-axis label below the bars.
            // Or, if each bar IS a category, then it should be:
            // data: ['Remote Workers', 'Office Workers', 'On the Road Workers', 'Hybrid Workers'],
            // However, to match the *visual* of a single group of 4 bars,
            // and have the legend define what each bar is:
            data: [''], // A single, empty category to group the bars
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false } // No visible x-axis labels
        }
    ],
    yAxis: [
        {
            type: 'value',
            min: 0,
            max: 100,
            interval: 25,
            axisLabel: {
                margin: 10,
                color: '#595959', // Matching image text color
                fontSize: 14
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: {
                show: true,
                lineStyle: {
                    type: 'dashed',
                    color: '#E0E0E0' // Lighter dashed lines
                }
            }
        }
    ],
    series: [
        {
            name: 'Remote Workers',
            type: 'bar',
            barWidth: 40, // Fixed width for each bar
            // barGap: '30%', // Optional: space between bars of different series (within same category)
            itemStyle: {
                color: '#A5B83C', // Olive Green
                borderRadius: [5, 5, 0, 0]
            },
            emphasis: { focus: 'series' },
            data: [0] // Value for the single x-axis category ''
        },
        {
            name: 'Office Workers',
            type: 'bar',
            barWidth: 40,
            itemStyle: {
                color: '#00B0CA', // Teal
                borderRadius: [5, 5, 0, 0]
            },
            emphasis: { focus: 'series' },
            data: [0]
        },
        {
            name: 'On the Road Workers',
            type: 'bar',
            barWidth: 40,
            itemStyle: {
                color: '#9C2AA0', // Purple
                borderRadius: [5, 5, 0, 0]
            },
            emphasis: { focus: 'series' },
            data: [0]
        },
        {
            name: 'Hybrid Workers',
            type: 'bar',
            barWidth: 40,
            itemStyle: {
                color: '#EB9700', // Orange
                borderRadius: [5, 5, 0, 0]
            },
            emphasis: { focus: 'series' },
            data: [0]
        }
    ]
};

const chartStyle = {
    height: '300px',
    width: '100%',
}

const PieChartStyle = {
    height: '330px',
    width: '100%',
}

const BarChartStyle = {
    height: '200px',
    width: '100%',
}

const handleImageUpload = async (file, onChange) => {
    try {
        const formData = new FormData();
        formData.append('image', file);

        const config = {
            method: 'post',
            url: `${apiUrl}/roi-Pages/upload-image`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: formData,
        };

        const response = await axios(config);

        if (response.data.result === 'success' && response.data.path) {
            onChange(response.data.path); // Relative path stored in JSON
        } else {
            const errorMsg = response.data && response.data.msg
                ? response.data.msg
                : 'Image upload failed';
            console.error('Error uploading image:', errorMsg);
            alert(errorMsg);
        }
    } catch (error) {
        console.error('Error uploading image:', error);
        alert('Error uploading image');
    }
};

//console.log(pucksettings, "pucksettings")
const config = {

    components: {

        //Header Components
        PageHeader: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Menu items",
                    arrayFields: {
                        Text: { type: "text" },
                        Action: {
                            type: "select",
                            label: "Choose action",
                            options: [
                                { label: "Open Page", value: "action-1" },
                                { label: "Show Block", value: "action-2" },
                                { label: "Hide Block", value: "action-3" },
                                { label: "Open Popup", value: "action-4" },
                            ],
                        },
                    },
                    getItemSummary: (item) => item.Text || "Item",
                    defaultItemProps: {
                        Text: "Menu item",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showCurrencyDropdown: {
                    type: "custom",
                    label: "Show currency",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showLanguageDropdown: {
                    type: "custom",
                    label: "Show language",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showRecalculateButton: {
                    type: "custom",
                    label: "Show recalculate button",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                transparentHeader: {
                    type: "custom",
                    label: "Transparent header",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                headerClass: {
                    type: "text",
                    label: "Extra CSS classes",
                },
                containerLayout: {
                    type: "select",
                    label: "Inner width",
                    options: [
                        { label: "Container (max width)", value: "container" },
                        { label: "Container fluid", value: "container-fluid" },
                        { label: "Edge to edge", value: "edge-to-edge" },
                    ],
                },
                recalculateButtonText: {
                    type: "text",
                    label: "Recalculate button text",
                },
                showContactUs: {
                    type: "custom",
                    label: "Show Contact us",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    defaultProps: {
                        value: false,
                    },
                },
                contactUsText: {
                    type: "text",
                    label: "Contact us label",
                },
                contactUsLink: {
                    type: "text",
                    label: "Contact us link (URL)",
                },


            },
            defaultProps: {
                logo: Logo,
                showCurrencyDropdown: false,
                showLanguageDropdown: false,
                transparentHeader: false,
                showRecalculateButton: false,
                headerClass: "",
                containerLayout: "container",
                recalculateButtonText: "Start Over",
                showContactUs: false,
                contactUsText: "Contact us",
                contactUsLink: "",
                items: [
                    { Text: "License", },
                    { Text: "Discovery", },
                    { Text: "Results", },

                ]
            },


            render: ({
                logo,
                items,
                hide,
                showCurrencyDropdown,
                showRecalculateButton,
                showLanguageDropdown,
                transparentHeader,
                headerClass,
                containerLayout,
                recalculateButtonText,
                showContactUs,
                contactUsText,
                contactUsLink,
            }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;
                const innerWidthClass =
                    containerLayout === "container-fluid"
                        ? "container-fluid"
                        : containerLayout === "edge-to-edge"
                            ? "w-100"
                            : "container";
                const headerClassNames = [
                    "roi-header-main",
                    transparentHeader && "header-transparent",
                    headerClass,
                ]
                    .filter(Boolean)
                    .join(" ");
                const contactHref = contactUsLink || "#";
                const contactIsExternal =
                    contactHref && /^https?:\/\//i.test(contactHref);

                return (
                    <div className={headerClassNames} style={{ opacity: inputOpacity }}>
                        <div className={innerWidthClass}>
                            <div className="header-wrapper">
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </Link>
                                <div className="nav-menu">
                                    <ul>
                                        {items.map((item, i) => (
                                            <li key={i}>
                                                <Link to="">{item.Text}</Link>
                                            </li>
                                        ))}
                                        {/* <li>
                                            <Link to="" className='active'>License</Link>
                                        </li>
                                        <li>
                                            <Link href="" className='disabled'>Discovery</Link>
                                        </li>
                                        <li>
                                            <Link href="" className='disabled'>Results</Link>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className='space'>
                                    {showCurrencyDropdown || showLanguageDropdown || showRecalculateButton || showContactUs ?
                                        <div className="d-flex currency-language align-items-center flex-wrap gap-2">
                                            {showRecalculateButton && <>
                                                <button type="button" className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3">

                                                    <Svg name="roi-recalculate-icon" /> {recalculateButtonText || "Start Over"}

                                                </button>
                                            </>}
                                            {showContactUs && (
                                                <a
                                                    href={contactHref}
                                                    className="btn roi-btn-primary header-contact-button"
                                                    target={contactIsExternal ? "_blank" : undefined}
                                                    rel={contactIsExternal ? "noopener noreferrer" : undefined}
                                                >
                                                    {contactUsText || "Contact us"}
                                                </a>
                                            )}
                                            {showLanguageDropdown && <div className="lang-wrap">
                                                <Svg name="language-globe" />
                                                <select className="language">
                                                    <option value="1">English</option>
                                                    <option value="2">Spanish</option>
                                                </select>
                                            </div>}
                                            {showCurrencyDropdown && <select className="currency">
                                                <option value="1">USD</option>
                                                <option value="2">GBP</option>
                                            </select>}
                                        </div>
                                        :
                                        ""}

                                </div>
                            </div>
                        </div>
                    </div>
                )
            },
        },
        PageHeader2: {
            fields: {
                logo1: {
                    type: "custom",
                    label: "Add logo 1",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                logo2: {
                    type: "custom",
                    label: "Add logo 2",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage2'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage2" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage2" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                logo3: {
                    type: "custom",
                    label: "Add logo 3",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage3'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage3" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage3" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                absolutePosition: {
                    type: "custom",
                    label: "Absolute position",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                whiteHeader: {
                    type: "custom",
                    label: "White header",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                logo1: Logo1,
                logo2: Logo2,
                logo3: Logo3,
                absolutePosition: false,
                whiteHeader: false,
            },


            render: ({ logo1, logo2, logo3, absolutePosition, whiteHeader }) => {
                // Calculate opacity based on hide value
                return (
                    <div className={`tco-header-main ${absolutePosition && 'absolute-position'} ${whiteHeader && 'header-white'}`}>
                        <div className="tco-container">
                            <div className="header-wrapper-top">
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo1)} alt="" />
                                </Link>
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo2)} alt="" />
                                </Link>
                            </div>
                            {logo3 &&
                                <div className="header-wrapper-bottom">
                                    <Link to="" className="logo">
                                        <img src={resolveMediaUrl(logo3)} alt="" />
                                    </Link>
                                </div>
                            }
                        </div>
                    </div>
                )
            },
        },
        ResultsPageHeader: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },


                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showDownloadButton: {
                    type: "custom",
                    label: "Show download button",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showRecalculateButton: {
                    type: "custom",
                    label: "Show recalculate button",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                contactUsButtonLink: {
                    type: "text",
                    label: "Contact us button link",

                },

            },
            defaultProps: {
                logo: Logo,
                showDownloadButton: true,
                showRecalculateButton: true,
                contactUsButtonLink: "https://survey-bis.com/contact-us",
            },


            render: ({ logo, hide, showDownloadButton, showRecalculateButton, contactUsButtonLink }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <div className={`roi-header-main`} style={{ opacity: inputOpacity }}>
                        <div className="container">
                            <div className="header-wrapper">
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </Link>

                                <div className='flex-grow-1'>
                                    {showDownloadButton || showRecalculateButton ?
                                        <div className="d-flex currency-language">
                                            {showRecalculateButton && <>
                                                <button className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3">
                                                    <div className="icon">
                                                        <Svg name="roi-recalculate-icon" />
                                                    </div>
                                                </button>
                                            </>}
                                            {contactUsButtonLink && <>
                                                <a target="_blank" href={contactUsButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3">Contact Us
                                                </a>
                                            </>}
                                            {showDownloadButton && <>
                                                <button className="d-inline-flex align-items-center btn roi-btn-primary gap-3">Download Report
                                                    <div className="icon">
                                                        <Svg name="roi-download-icon" />
                                                    </div>
                                                </button>
                                            </>}

                                        </div>
                                        :
                                        ""}

                                </div>
                            </div>
                        </div>
                    </div>
                )
            },
        },
        ResultsPageHeader2: {
            fields: {
                logo1: {
                    type: "custom",
                    label: "Add logo 1",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                logo2: {
                    type: "custom",
                    label: "Add logo 2",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage2'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage2" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage2" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                logo3: {
                    type: "custom",
                    label: "Add logo 3",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage3'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>
                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage3" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage3" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },
                absolutePosition: {
                    type: "custom",
                    label: "Absolute position",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                transparentHeader: {
                    type: "custom",
                    label: "Transparent header",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: true, // Initially, the input should not be hidden
                    },
                },


                showDownloadButton: {
                    type: "custom",
                    label: "Show download button",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                showRecalculateButton: {
                    type: "custom",
                    label: "Show recalculate button",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                contactUsButtonLink: {
                    type: "text",
                    label: "Contact us button link",

                },

            },
            defaultProps: {
                logo1: Logo1,
                logo2: Logo2,
                logo3: Logo3,
                absolutePosition: false,
                transparentHeader: true,
                showDownloadButton: true,
                showRecalculateButton: false,
                contactUsButtonLink: "https://survey-bis.com/contact-us",
            },

            render: ({ logo1, logo2, logo3, absolutePosition, transparentHeader, showDownloadButton, showRecalculateButton, contactUsButtonLink }) => {
                return (
                    <div className={`tco-header-main ${absolutePosition && 'absolute-position'} ${!transparentHeader && 'header-white'}`}>
                        <div className="tco-container">
                            <div className="header-wrapper-top">
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo1)} alt="" />
                                </Link>
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo2)} alt="" />
                                </Link>
                            </div>
                            {logo3 &&
                                <div className="header-wrapper-bottom d-flex justify-content-between align-items-center">
                                    <Link to="" className="logo">
                                        <img src={resolveMediaUrl(logo3)} alt="" />
                                    </Link>
                                    <div className='flex-grow-1'>
                                        {showDownloadButton || showRecalculateButton ?
                                            <div className="d-flex currency-language align-items-center justify-content-end">
                                                {showRecalculateButton && <>
                                                    <button className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3">
                                                        <div className="icon">
                                                            <Svg name="roi-recalculate-icon" />
                                                        </div>
                                                    </button>
                                                </>}
                                                {showDownloadButton && <>
                                                    <button className="d-inline-flex align-items-center btn roi-btn-primary roi-btn-primary-gradient gap-2">

                                                        <Svg name="roi-download-icon-2" />

                                                        Download Report

                                                    </button>
                                                </>}
                                                {contactUsButtonLink && <>
                                                    <a target="_blank" href={contactUsButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-2">
                                                        <div className="icon">
                                                            <Svg name="roi-schedule-icon" />
                                                        </div>
                                                        Schedule a Consultation
                                                    </a>
                                                </>}


                                            </div>
                                            :
                                            ""}

                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            },
        },

        PageHeaderTransparent: {
            fields: {
                fields: {
                    logo: {
                        type: "custom",
                        label: "Add logo",
                        render: ({ name, onChange, value, field }) => (
                            <>
                                <FieldLabel label={field.label}></FieldLabel>

                                <input
                                    type="file"
                                    id='uploadImage'
                                    className='d-none'
                                    // defaultValue={value}
                                    name={name}
                                    // onChange={(e) => onChange(e.currentTarget.value)}
                                    onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                />
                                {/* <label htmlFor="uploadImage" className='icon-upload'>
                                    
                                    <button className='remove-btn'>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={Logo} className='img-fluid' alt="" />
                                    </div>

                                </label> */}
                                {value ? (<>
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        <button className='remove-btn' onClick={() => onChange('')}>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                        </div>
                                    </label>
                                </>) : (
                                    <>
                                        <label htmlFor="uploadImage" className='icon-upload'>

                                            {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                            <div className="icon-upload">
                                                {/**Render remove button when icon is uploaded**/}
                                                <span>Upload image</span>
                                                {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                            </div>
                                        </label>
                                    </>
                                )}


                            </>
                        ),
                    },

                    hide: {
                        type: "custom",
                        label: "Hide",
                        render: ({ name, onChange, value, field }) => (
                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                    <div className="check-switch">
                                        <input
                                            type="checkbox"
                                            defaultChecked={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.checked)} />
                                    </div>
                                </div>
                            </>
                        ),
                        // We need to add defaultProps for the "hide" field
                        defaultProps: {
                            value: false, // Initially, the input should not be hidden
                        },
                    },


                },
                defaultProps: {
                    logo: Logo,
                },
            },

            render: ({ logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <div className='roi-header-transparent' style={{ opacity: inputOpacity }}>
                        <div className="container">
                            <div className="header-wrapper">
                                <a className="logo">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                )
            },
        },

        // Banner Layouts
        BannerLeftTextRightImage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },


                Style: {
                    type: "radio",
                    label: "Section style",
                    options: pucksettings['sectionStyle'],
                },

                Button: {
                    type: "object",
                    objectFields: {
                        // uuid: "BannerLeftTextRightImage-uuid", // object uuid for BannerLeftTextRightImage button
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: pucksettings['buttonAction'],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page 2",
                            options: pucksettings['selectPage'],

                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: pucksettings['ButtonStyle'],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: pucksettings['buttonIcon'],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },



                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={bannerImageLaptop} className='img-fluid' alt="" />
                                </div>

                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                Heading: {
                    title: "TCO Calculator",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "<p>Explore your Vodafone plan options effortlessly with our Assessment Calculator tool. Simply input your usage details, preferences, and needs, and gain insights into the most suitable plans tailored to you. </p><p>From data allowances to international calls, the Assessment Calculator empowers you to make informed decisions about your telecommunications services. Say goodbye to guesswork and hello to personalized solutions with Vodafone's user-friendly tool, ensuring you get the most out of your mobile experience.</p>",
                    descriptionFont: "fs-20",
                },

                Style: "style1",

                Button: {
                    uuid: "",
                    buttonText: "Start Assesment",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "no",
                    buttonAction: "",
                    PageList: ""
                },

                image: bannerImageLaptop,

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Button, Padding, Style, image, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Style} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="row align-items-center ">

                                    <div className="col-lg-6">
                                        <div className="banner-text">
                                            <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                            <div className="text-part">
                                                <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                </div>
                                            </div>

                                            <div className="button-wrap">
                                                {Button.buttonicon === "yes" ?

                                                    <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                        <div className="icon">
                                                            <Svg name="roi-button-icon" />
                                                        </div>
                                                    </button>
                                                    :
                                                    <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="img-wrapper">
                                            <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        BannerCenterText: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],
                        },
                    },
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: pucksettings['ButtonStyle'],

                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: pucksettings['buttonIcon'],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },

                Style: {
                    type: "radio",
                    label: "Section style",
                    options: pucksettings['sectionStyle'],
                },

                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                                
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                </div>

                            </label> */}

                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus rutrum vitae lorem sed dignissim. Donec ut auctor lectus, ",
                    descriptionFont: "fs-22",
                },

                Style: "style1",

                Button: {
                    uuid: "",
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },

                image: BgImage,

                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Button, Padding, image, Style, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaUrl(image)}")`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', opacity: inputOpacity }}>
                            <div className='overlay'></div>
                            <div className="container position-relative">
                                <div className="row align-items-center justify-content-center">

                                    <div className="col-lg-8">
                                        <div className="banner-text text-center">
                                            <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h1>

                                            <div className="text-part">
                                                <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                </div>
                                            </div>

                                            <div className="button-wrap">
                                                {Button.buttonicon === "yes" ?
                                                    <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                        <div className="icon">
                                                            <Svg name="roi-button-icon" />
                                                        </div>
                                                    </button>
                                                    :
                                                    <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Cards Layouts
        CardLayout1: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },

                Card1: {
                    title: 'Card 1',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: pucksettings['buttonAction'],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page 1",
                            options: pucksettings['selectPage'],
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },

                    },
                },

                Card2: {
                    title: 'Card 2',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: pucksettings['buttonAction'],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page 3",
                            options: pucksettings['selectPage'],

                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                    },
                },

                Card3: {
                    title: 'Card 3',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: pucksettings['buttonAction'],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page 4",
                            options: pucksettings['selectPage'],

                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                    },
                },

                Card4: {
                    title: 'Card 4',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: pucksettings['buttonAction'],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page 5",
                            options: pucksettings['selectPage'],

                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                    },
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",

                },
                Card1: {
                    uuid: "", // default uuid for custom button
                    title: "Card 1",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""
                },
                Card2: {
                    uuid: "", // default uuid for custom button
                    title: "Card 2",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""

                },
                Card3: {
                    uuid: "", // default uuid for custom button
                    title: "",
                    text: "",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""
                },

                Card4: {
                    uuid: "", // default uuid for custom button
                    title: "",
                    text: "",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },

            },
            render: ({ Heading, Description, Padding, Card1, Card2, Card3, Card4, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="section-heading mb-3 mb-md-5 text-center">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.descriptionFont}>{Description.text}</p>
                                </div>
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card1.title}</h4>
                                                        <p>{Card1.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card2.title}</h4>
                                                        <p>{Card2.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {Card3.title && <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card3.title}</h4>
                                                        <p>{Card3.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        {Card4.title && <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card4.title}</h4>
                                                        <p>{Card4.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        CardLayout2: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },

                Card1: {
                    title: 'Card 1',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Card2: {
                    title: 'Card 2',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Card3: {
                    title: 'Card 3',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",
                },
                Card1: {
                    uuid: "",
                    title: "Card 1",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },
                Card2: {
                    uuid: "",
                    title: "Card 2",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },
                Card3: {
                    uuid: "",
                    title: "Card 3",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Padding, Card1, Card2, Card3, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="section-heading mb-3 mb-md-5 text-center">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.descriptionFont}>{Description.text}</p>
                                </div>
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card1.title}</h4>
                                                        <p>{Card1.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card2.title}</h4>
                                                        <p>{Card2.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card3.title}</h4>
                                                        <p>{Card3.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Form Layouts
        SinglePage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-40",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <DropZone zone="nav-wrapper" allow={["FormNav", "FormNav2"]} />
                                <div className="form-wrapper">
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.descriptionFont}>{Description.text}</p>
                                    </div>
                                    <div className="form-inner">
                                        <DropZone zone="form-wrapper" disallow={["SinglePage", "WizardForm"]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        FormNav: {
            fields: {

                items: {
                    type: "array",
                    label: "Form Navigation",
                    arrayFields: {
                        Title: { type: "text" },
                        Link: { type: "text" },
                        isActive: {
                            type: "custom",
                            label: "Is Active?",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                id={name}
                                                name="isActive"
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                    getItemSummary: (item) => item.Title || "Title",
                    defaultItemProps: {
                        Title: "Title",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                items: [
                    {
                        Title: "Company",
                        isActive: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Technology",
                        isActive: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Staff",
                        isActive: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                ]
            },
            render: ({ items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>

                        <ul className="nav nav-tabs nav-tabs-single">
                            {items.map((item, i) => (
                                <li className="nav-item" role="presentation" key={i}>
                                    {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                    <button className={item.isActive == true ? 'nav-link active' : 'nav-link'}>{item.Title}</button>
                                </li>
                            ))}
                        </ul>


                    </>
                )

            },
        },

        FormNav2: {
            fields: {
                items: {
                    type: "array",
                    label: "Wizard Navigation",
                    arrayFields: {
                        Title: { type: "text" },
                        Link: { type: "text" },
                        isActive: {
                            type: "custom",
                            label: "Is Active?",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                id={name}
                                                name="isActive"
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>
                                </>
                            ),
                        },
                        isDone: {
                            type: "custom",
                            label: "Is Done?",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                id={name}
                                                name="isDone"
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>
                                </>
                            ),
                        },
                    },
                    getItemSummary: (item) => item.Title || "Title",
                    defaultItemProps: {
                        Title: "Title",
                        isActive: false,
                        isDone: false,
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    defaultProps: {
                        value: false,
                    },
                },
            },
            defaultProps: {
                items: [
                    {
                        Title: "Your Details",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Your Business",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Employee Roles",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Additional Capabilities",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Security Needs",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Basic Security",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "IT Support",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                    {
                        Title: "Review & Calculate",
                        isActive: false,
                        isDone: false,
                        buttonAction: "JumpToPage",
                        buttonValue: "",
                        uuid: "",
                    },
                ]
            },
            render: ({ items, hide }) => {
                const inputOpacity = hide ? 0.5 : 1;

                // Calculate progress percentage
                const totalSteps = items.length;
                const completedSteps = items.filter(item => item.isDone).length;
                const progressPercentage = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

                return (
                    <>
                        {/* Wizard Progress Steps */}
                        <div className="wizard-progress" style={{ opacity: inputOpacity }}>
                            <div className="wizard-steps">
                                {items.map((item, i) => (
                                    <div key={i} className={`wizard-step ${item.isDone ? 'completed' : ''} ${item.isActive ? 'active' : ''}`}>
                                        <div className="step-circle">
                                            {item.isDone ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} viewBox="0 0 16 12" fill="none">
                                                    <path d="M1.37207 4.63043L6.18052 9.43888L14.532 1.08736" stroke="white" strokeWidth={3} />
                                                </svg>

                                            ) : (
                                                <span>{i + 1}</span>
                                            )}
                                        </div>
                                        <div className="step-label">{item.Title}</div>
                                        {i < items.length - 1 && (
                                            <div className={`step-connector ${item.isDone ? 'completed' : ''}`}></div>
                                        )}
                                    </div>
                                ))}
                            </div>


                        </div>


                    </>
                )
            },
        },


        FormNav3: {
            fields: {
                items: {
                    type: "array",
                    label: "Wizard Navigation",
                    arrayFields: {
                        Title: { type: "text" },
                        targetID: { type: "text" },


                    },
                    getItemSummary: (item) => item.Title || "Title",
                    defaultItemProps: {
                        Title: "Title",
                        targetID: "",
                    },
                },

            },
            defaultProps: {
                items: [
                    {
                        Title: "Form 1",
                        targetID: "",
                        uuid: "",
                    },
                    {
                        Title: "Form 2",
                        targetID: "",
                        uuid: "",
                    },

                ]
            },
            render: ({ items }) => {

                return (
                    <>
                        {/* Wizard Progress Steps */}
                        <div className="wizard-progress">
                            <div className="wizard-steps">
                                {items.map((item, i) => (
                                    <a href={`#${item.targetID}`} key={i} className={`wizard-step ${i === 0 ? 'active' : ''}`}>
                                        <div className="step-circle">
                                            <span>{i + 1}</span>
                                        </div>
                                        <div className="step-label">{item.Title}</div>
                                    </a>
                                ))}
                            </div>


                        </div>


                    </>
                )
            },
        },


        WizardForm: {

            fields: {

                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                        Description: "Section description",
                    },

                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },
                items: [
                    { Title: "Company", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Technology", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Staff", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                ]
            },
            render: ({ Padding, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">

                                    {items.map((item, i) => (
                                        <li className="nav-item" role="presentation" key={i}>
                                            {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                            <button className={i === 0 ? 'nav-link active' : 'nav-link'} id={`tab-${i}`} data-bs-toggle="tab" data-bs-target={`#tab-${i}-pane`} type="button" role="tab" aria-controls={`tab-${i}-pane`} aria-selected="false">{item.Title}</button>
                                        </li>
                                    ))}
                                </ul>
                                <div className="form-wrapper">
                                    <div className="tab-content" id="myTabContent">
                                        {items.map((item, i) => (
                                            <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>
                                                <div className="section-heading mb-3 mb-md-4">
                                                    <h2 className={`heading fw-700 fs-40`}>{item.Title}</h2>
                                                    <p className='fs-22'>{item.Description}</p>
                                                </div>
                                                <div className="form-inner">
                                                    <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </>
                )

            },
        },

        //Form Elements

        InputTextField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                showLabel: {
                    type: "custom",
                    label: "Show label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                disableEditing: {
                    type: "custom",
                    label: "Disable Editing",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },


                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },
                hintStyle: {
                    type: "radio",
                    options: [
                        { label: "Dark", value: "dark" },
                        { label: "White", value: "white" },
                    ],
                    defaultProps: {
                        value: "default"
                    },
                },
                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Label",
                showLabel: true,
                disableEditing: false,
                placeholder: "Placeholder",
                value: "Value",
                hint: '',
                hintStyle: "dark",
                required: false,
                // errorMessage: "Error message",
                Style: {
                    BackgroundColor: "#fff",
                    Color: "#333",
                    Height: 55,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 13,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }
            },
            render: ({ label, showLabel, disableEditing, value, placeholder, required, errorMessage, hint, hintStyle, hide, Style, Font, Border, Padding, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                            }
                        }>
                            {showLabel && <label className='field-label'><span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className='required'>*</span>} {hint &&
                                <div className={`hint ${hintStyle}`}>
                                    <button className="info"><Svg name="hint-button" /></button>
                                    <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                    </div>
                                </div>
                            }</label>}
                            <div className="position-relative">
                                <input {...(disableEditing ? { disabled: true } : {})} type="text" value={value} className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} style={{
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Color}`,

                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                    borderStyle: `${Border?.BorderStyle}`,
                                    borderColor: `${Border?.BorderColor}`,
                                    borderWidth: `${Border?.BorderWidth}px`,
                                    borderRadius: `${Border?.BorderRadius}px`,
                                    height: `${Style?.Height}px`,
                                    textAlign: Font?.Align,
                                }} />

                                {!showLabel && hint &&
                                    <div className={`hint ${hintStyle}`}>
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </div>


                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        InputNumberField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                showLabel: {
                    type: "custom",
                    label: "Show label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                disableEditing: {
                    type: "custom",
                    label: "Disable Editing",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                value: {
                    type: "number",
                    label: "Value",

                },

                Prefix: {
                    type: "select",
                    label: "Prefix/Postfix",
                    options: [
                        { label: "None", value: "none" },
                        { label: "%", value: "%" },
                        { label: "Currency", value: "currency" },

                    ],
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },



                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },
                hintStyle: {
                    type: "radio",
                    options: [
                        { label: "Dark", value: "dark" },
                        { label: "White", value: "white" },
                    ],
                },
                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Label",
                showLabel: true,
                disableEditing: false,
                placeholder: "Placeholder",
                value: '',
                hint: '',
                hintStyle: "dark",
                required: false,
                Prefix: "none",
                // errorMessage: "Error message",
                Style: {
                    BackgroundColor: "#fff",
                    Color: "#333",
                    Height: 55,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 13,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }
            },
            render: ({ label, showLabel, value, placeholder, required, errorMessage, hint, hintStyle, hide, Prefix, Style, Font, Border, Padding, Margin, disableEditing }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                            }
                        }>
                            {showLabel && <label className='field-label'><span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className='required'>*</span>} {hint &&
                                <div className={`hint ${hintStyle}`}>
                                    <button className="info"><Svg name="hint-button" /></button>
                                    <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                    </div>
                                </div>
                            }</label>}
                            <div className="position-relative">
                                {Prefix == 'none' &&
                                    <input {...(disableEditing ? { disabled: true } : {})} type="number" value={value} className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required}
                                        style={{
                                            backgroundColor: `${Style?.BackgroundColor}`,
                                            color: `${Style?.Color}`,

                                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                            borderStyle: `${Border?.BorderStyle}`,
                                            borderColor: `${Border?.BorderColor}`,
                                            borderWidth: `${Border?.BorderWidth}px`,
                                            borderRadius: `${Border?.BorderRadius}px`,
                                            height: `${Style?.Height}px`,
                                            textAlign: Font?.Align,
                                        }}
                                    />
                                }

                                {Prefix == '%' &&
                                    <div className="input-group percent">
                                        <input {...(disableEditing ? { disabled: true } : {})} type="number" value={value} className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required}
                                            style={{
                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                color: `${Style?.Color}`,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                borderStyle: `${Border?.BorderStyle}`,
                                                borderColor: `${Border?.BorderColor}`,
                                                borderWidth: `${Border?.BorderWidth}px`,
                                                borderRadius: `${Border?.BorderRadius}px`,
                                                height: `${Style?.Height}px`,
                                                textAlign: Font?.Align,
                                            }}
                                        />
                                        <span className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'}`} style={{
                                            color: `${Style?.Color}`,
                                        }}>%</span>
                                    </div>

                                }

                                {Prefix == 'currency' &&
                                    <div className="input-group currency">
                                        <span className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'}`}
                                            style={{
                                                color: `${Style?.Color}`,
                                            }}
                                        >$</span>
                                        {/**Change this currency depending upon default currency**/}
                                        <input {...(disableEditing ? { disabled: true } : {})} type="number" value={value} className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required}
                                            style={{
                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                color: `${Style?.Color}`,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                                borderStyle: `${Border?.BorderStyle}`,
                                                borderColor: `${Border?.BorderColor}`,
                                                borderWidth: `${Border?.BorderWidth}px`,
                                                borderRadius: `${Border?.BorderRadius}px`,
                                                height: `${Style?.Height}px`,
                                                textAlign: Font?.Align,
                                            }}
                                        />

                                    </div>
                                }



                                {!showLabel && hint &&
                                    <div className={`hint ${hintStyle}`}>
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </div>

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        TextareaField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                showLabel: {
                    type: "custom",
                    label: "Show label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Textarea",
                showLabel: true,
                value: "Value",
                placeholder: "Placeholder",
                required: false,
                // errorMessage: "Error message",
                Style: {
                    BackgroundColor: "#fff",
                    Color: "#333",
                    Height: 100,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 13,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }
            },
            render: ({ label, showLabel, value, placeholder, required, errorMessage, hide, Style, Font, Border, Padding, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                            }
                        }>
                            {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <textarea className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} value={value}
                                style={{
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Color}`,

                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                    borderStyle: `${Border?.BorderStyle}`,
                                    borderColor: `${Border?.BorderColor}`,
                                    borderWidth: `${Border?.BorderWidth}px`,
                                    borderRadius: `${Border?.BorderRadius}px`,
                                    height: `${Style?.Height}px`,
                                    textAlign: Font?.Align,
                                }} />

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Dropdown: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                showLabel: {
                    type: "custom",
                    label: "Show label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },


                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        DropdownSize: {
                            type: "custom",
                            label: "Dropdown icon size",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },


            },
            defaultProps: {
                uuid: "",
                label: "Dropdown label",
                showLabel: true,
                required: false,
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                Style: {
                    BackgroundColor: "#fff",
                    DropdownSize: 20,
                    Height: 55,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 30,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }
                // errorMessage: "Error message",
            },
            render: ({ label, showLabel, required, errorMessage, items, hide, Style, Font, Border, Padding, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                            }}>
                            {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <select className={`form-control ${Font?.fontWeight} ${Font?.fontSize} ${errorMessage ? 'error' : ''}`}
                                style={{
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    backgroundSize: `${Style?.DropdownSize}px`,
                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                    borderStyle: `${Border?.BorderStyle}`,
                                    borderColor: `${Border?.BorderColor}`,
                                    borderWidth: `${Border?.BorderWidth}px`,
                                    borderRadius: `${Border?.BorderRadius}px`,
                                    height: `${Style?.Height}px`
                                }}
                            >
                                <option value>--Select--</option>
                                {items.map((item, i) => (
                                    <option value={item.Option}>{item.Option}</option>
                                ))}
                            </select>


                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        Checkbox: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },        // Label shown in UI
                        Description: { type: "text" },   // Helper/description text
                        Value: { type: "text" },         // Actual value saved for this option
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                        Description: "Enter description",
                        // By default, use the same text as label for value.
                        // Editors can override Value if they need a different stored value.
                        Value: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                Style: {
                    type: "object",
                    objectFields: {
                        layout: {
                            type: "select",
                            options: [
                                { label: "Full Width (Stacked)", value: "full" },
                                { label: "Two Columns", value: "two-column" },
                                { label: "Boxed Grid", value: "boxed" }
                            ]
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Checkbox label",
                required: false,
                ID: 'CheckBox1',
                items: [
                    {
                        Option: "Option 1",
                        Description: "",
                        uuid: "",
                    },
                    {
                        Option: "Option 2",
                        Description: "",
                        uuid: "",
                    }

                ],
                Style: {
                    layout: "full",
                    customMargin: false
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID, hide, Margin, Style }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                // Determine layout class - default to "full" if not specified
                let layoutClass = "full"; // default
                if (Style && Style.layout) {
                    const layout = String(Style.layout).toLowerCase().trim();
                    if (layout === "full" || layout === "two-column" || layout === "boxed") {
                        layoutClass = layout;
                    }
                }

                // Construct className with layout class
                const wrapClassName = `roi-check-wrap ${layoutClass}`;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                            }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className={wrapClassName}>
                                {items.map((item, i) => (
                                    <div className="form-check" key={i}>
                                        <input
                                            className="form-check-input"
                                            name={ID}
                                            type="checkbox"
                                            id={`${ID}-${i}`}
                                            value={item.uuid || item.Option || i}
                                        />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            <span className="option" dangerouslySetInnerHTML={{ __html: item.Option }} />
                                            <span className="description" dangerouslySetInnerHTML={{ __html: item.Description }} />
                                        </label>
                                    </div>
                                ))}
                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        // Checkbox2: uses the same fields and data structure as Radio,
        // but renders as checkboxes instead of radio buttons in the editor.
        Checkbox2: {
            fields: {
                selectionMode: {
                    type: "select",
                    label: "Selection mode",
                    options: [
                        { label: "Multi select", value: "multi" },
                        { label: "Single select", value: "single" },
                    ],
                    defaultProps: {
                        value: "multi",
                    },
                },
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                value={value}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className="form-control"
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                hintStyle: {
                    type: "radio",
                    options: [
                        { label: "Dark", value: "dark" },
                        { label: "White", value: "white" },
                    ],
                    defaultProps: {
                        value: "default",
                    },
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                value={value}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        RadioOption: { type: "text", label: "Label" },
                        Description: { type: "text", label: "Description" },   // Helper/description text
                        value: { type: "text", label: "Value" },
                        numberValue: { type: "number", label: "Number Value", defaultValue: 0, min: 0, step: 1 },
                    },
                    getItemSummary: (item) => item.RadioOption || "Options",
                    defaultItemProps: {
                        RadioOption: "Enter option",
                        Description: "",
                        value: "",
                        numberValue: 0,
                    },
                },
                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className="label-wrp" label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)}
                                    />
                                </div>
                            </div>
                        </>
                    ),
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className="label-wrp" label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)}
                                    />
                                </div>
                            </div>
                        </>
                    ),
                    defaultProps: {
                        value: false,
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                Style: {
                    type: "object",
                    objectFields: {
                        layout: {
                            type: "select",
                            options: [
                                { label: "Full Width (Stacked)", value: "full" },
                                { label: "Two Columns", value: "two-column" },
                                { label: "Boxed Grid", value: "boxed" }
                            ]
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
            },
            defaultProps: {
                uuid: "",
                label: "Checkbox 2 label",
                hint: "",
                hintStyle: "default",
                value: 0,
                required: false,
                ID: "Checkbox2",
                items: [
                    {
                        RadioOption: "Option 1",
                        Description: "",
                        uuid: "",
                    },
                    {
                        RadioOption: "Option 2",
                        Description: "",
                        uuid: "",
                    },
                ],
                Style: {
                    layout: "full",
                    customMargin: false
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID, hide, value, hint, hintStyle, Style, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                // Determine layout class - default to "full" if not specified
                let layoutClass = "full"; // default
                if (Style && Style.layout) {
                    const layout = String(Style.layout).toLowerCase().trim();
                    if (layout === "full" || layout === "two-column" || layout === "boxed") {
                        layoutClass = layout;
                    }
                }

                // Construct className with layout class
                const wrapClassName = `roi-check-wrap ${layoutClass}`;

                const style = {
                    margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }

                return (
                    <>
                        <div className="roi-form-group position-relative" style={{ opacity: inputOpacity, ...style }}>
                            {label && (
                                <label className="field-label">
                                    {label} {required && <span className="required">*</span>}
                                    {hint && (
                                        <div className={`hint ${hintStyle}`}>
                                            <button className="info">
                                                <Svg name="hint-button" />
                                            </button>
                                            <div
                                                className="popover"
                                                dangerouslySetInnerHTML={{ __html: hint }}
                                            ></div>
                                        </div>
                                    )}
                                </label>
                            )}

                            <div className={wrapClassName}>
                                {items.map((item, i) => {
                                    const inputId = `${ID}-${i}`;
                                    return (
                                        <div className="form-check" key={i}>
                                            <input
                                                className="form-check-input"
                                                name={ID}
                                                type="checkbox"
                                                id={inputId}
                                                value={item.value}
                                            // In admin editor we don't manage checked state; runtime will.
                                            />
                                            <label className="form-check-label" htmlFor={inputId}>
                                                <span className="option" dangerouslySetInnerHTML={{ __html: item.RadioOption }} />
                                                <span className="description" dangerouslySetInnerHTML={{ __html: item.Description }} />
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                );
            },
        },

        Radio: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                value={value}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },
                hintStyle: {
                    type: "radio",
                    options: [
                        { label: "Dark", value: "dark" },
                        { label: "White", value: "white" },
                    ],
                    defaultProps: {
                        value: "default"
                    },
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                value={value}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        RadioOption: { type: "text" },
                        value: { type: "text" },
                    },
                    getItemSummary: (item) => item.RadioOption || "Options",
                    defaultItemProps: {
                        RadioOption: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                uuid: "",
                label: "Radio button label",
                hint: "",
                hintStyle: "default",
                value: 0,
                required: false,
                ID: 'RadioButton1',
                items: [
                    {
                        RadioOption: "Option 1",
                        uuid: "",
                    },
                    {
                        RadioOption: "Option 2",
                        uuid: "",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID, hide, value, hint, hintStyle }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}
                                {hint &&
                                    <div className={`hint ${hintStyle}`}>
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </label>
                            }

                            <div className="roi-check-wrap">
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.RadioOption}
                                        </label>
                                    </div>
                                ))}

                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        PhoneNumber: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                showLabel: {
                    type: "custom",
                    label: "Show label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                value: {
                    type: "custom",
                    label: "Phone number",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Phone number",
                showLabel: true,
                placeholder: "Enter phone number",
                value: "+91 3335 335353",
                required: false,
                // errorMessage: "Error message",
                Style: {
                    BackgroundColor: "#fff",
                    Color: "#333",
                    Height: 55,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 13,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }


            },
            render: ({ label, showLabel, placeholder, required, errorMessage, value, hide, Style, Font, Border, Padding, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                            }
                        }>
                            {showLabel && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text"
                                className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} style={{
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Color}`,

                                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                    borderStyle: `${Border?.BorderStyle}`,
                                    borderColor: `${Border?.BorderColor}`,
                                    borderWidth: `${Border?.BorderWidth}px`,
                                    borderRadius: `${Border?.BorderRadius}px`,
                                    height: `${Style?.Height}px`,
                                    textAlign: Font?.Align,
                                }} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Email: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Email",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Height: {
                            type: "custom",
                            label: "Height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: pucksettings['BorderWidth'],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                Font: {
                    type: "object",
                    objectFields: {
                        fontSize: {
                            label: "Field font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Field font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Email",
                placeholder: "Enter email",
                value: "admin@testmail.com",
                required: false,
                // errorMessage: "Error message",
                Style: {
                    BackgroundColor: "#fff",
                    Color: "#333",
                    Height: 55,
                    customMargin: false
                },


                Padding: {
                    top: 12,
                    bottom: 12,
                    left: 13,
                    right: 13,
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 1,
                    BorderRadius: 4,
                    BorderColor: "#C3C8CC"
                },
                Font: {
                    fontSize: "fs-18",
                    fontWeight: "fs-400"
                }
            },
            render: ({ label, placeholder, required, errorMessage, value, hide, Style, Font, Border, Padding, Margin }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`
                            }
                        }>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text" placeholder={placeholder} value={value} required={required} className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : 'fs-18'} ${errorMessage ? 'error' : ''}`} style={{
                                backgroundColor: `${Style?.BackgroundColor}`,
                                color: `${Style?.Color}`,

                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                borderStyle: `${Border?.BorderStyle}`,
                                borderColor: `${Border?.BorderColor}`,
                                borderWidth: `${Border?.BorderWidth}px`,
                                borderRadius: `${Border?.BorderRadius}px`,
                                height: `${Style?.Height}px`,
                                textAlign: Font?.Align,
                            }} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Date: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                uuid: "",
                label: "Date",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                            <DateField />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}

                        </div>
                    </>
                )

            },
        },

        Range: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                uniqueId: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                startValue: {
                    type: "object",
                    objectFields: {
                        value: {
                            label: "Value",
                            type: "number",
                        },

                        unit: {
                            label: "Unit",
                            type: "text",
                        },


                    },
                },
                endValue: {
                    type: "object",
                    objectFields: {
                        value: {
                            label: "Value",
                            type: "number",
                        },

                        unit: {
                            label: "Unit",
                            type: "text",
                        },


                    },
                },
                startLabel: {
                    type: "custom",
                    label: "Start Label (above start value)",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                placeholder="e.g., Voice-heavy"
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                endLabel: {
                    type: "custom",
                    label: "End Label (above end value)",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                placeholder="e.g., Digital-heavy"
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                helperText: {
                    type: "custom",
                    label: "Helper Text (below slider)",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                name={name}
                                rows={3}
                                placeholder="e.g., 0 = 100% Voice interactions&#10;100 = 100% Digital interactions"
                                onChange={(e) => onChange(e.currentTarget.value)}
                                style={{ width: '100%', resize: 'vertical' }}
                            />
                        </>
                    ),
                },

                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                uuid: "",
                label: "Range",
                uniqueId: "",
                startValue: {
                    value: 0,
                    unit: "",
                },
                endValue: {
                    value: 100,
                    unit: "",
                },
                startLabel: "",
                endLabel: "",
                helperText: "",
                required: false,
            },
            render: ({ label, uniqueId, required, hide, startValue, endValue, startLabel, endLabel, helperText }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* Labels above the slider */}
                            {(startLabel || endLabel) && (
                                <div className="d-flex justify-content-between mb-1">
                                    <div className="range-top-label" style={{ fontSize: '12px', color: '#666' }}>{startLabel || ''}</div>
                                    <div className="range-top-label" style={{ fontSize: '12px', color: '#666' }}>{endLabel || ''}</div>
                                </div>
                            )}
                            <div className="d-flex align-items-center">
                                <div className="">{startValue.value} {startValue.unit}</div>
                                <div className="flex-grow-1">
                                    <Range startValue={startValue} endValue={endValue} uniqueId={uniqueId} />
                                </div>
                                <div className="">{endValue.value} {endValue.unit}</div>
                            </div>
                            {/* Helper text below the slider */}
                            {helperText && (
                                <div className="range-helper-text mt-2" style={{ fontSize: '12px', color: '#888', whiteSpace: 'pre-line' }}>
                                    {helperText}
                                </div>
                            )}
                        </div>
                    </>
                )

            },
        },

        Toggle: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                uuid: "",
                label: "Toggle button",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="check-switch">
                                <label>No</label>
                                <input
                                    id="agree-check"
                                    type="checkbox"
                                    defaultChecked
                                />
                                <label>Yes</label>

                            </div>

                        </div>
                    </>
                )

            },
        },


        Button: {
            fields: {
                buttonText: {
                    type: "custom",
                    label: "Text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />

                        </>
                    ),
                },
                buttonAlignment: {
                    type: "radio",
                    label: "Alignment",
                    options: pucksettings['TextAlign'],
                },
                buttonAction: {
                    type: "select",
                    label: "Action on button click",
                    options: pucksettings['buttonAction'],
                },
                popupTargetId: {
                    type: "custom",
                    label: "Popup Target ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                PageList: {
                    type: "select",
                    label: "Select page 6",
                    options: pucksettings['selectPage'],

                },
                buttonLink: {
                    type: "custom",
                    label: "Link",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },
                buttonStyle: {
                    type: "radio",
                    label: "Style",
                    options: pucksettings['ButtonStyle'],

                },

                buttonicon: {
                    type: "radio",
                    label: "Show icon",
                    options: pucksettings['buttonIcon'],
                },

                iconPosition: {
                    type: "radio",
                    label: "Show icon",
                    options: pucksettings['iconPosition'],
                },


                spacing: {
                    type: "number",
                    label: "Text-Icon Gap",
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                customStyle: {
                    type: "custom",
                    label: "Use custom styling",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Padding: {
                            type: "object",
                            objectFields: {
                                top: {
                                    label: "Top",
                                    type: "number",
                                },

                                bottom: {
                                    label: "Bottom",
                                    type: "number",
                                },
                                left: {
                                    label: "Left",
                                    type: "number",
                                },
                                right: {
                                    label: "Right",
                                    type: "number",
                                },


                            },
                        },
                        Border: {
                            type: "object",
                            objectFields: {
                                BorderStyle: {
                                    label: "Border style",
                                    type: "select",
                                    options: pucksettings['BorderStyle'],

                                },
                                BorderWidth: {
                                    label: "Border Width",
                                    type: "select",
                                    options: pucksettings['BorderWidth'],
                                },
                                BorderColor: {
                                    type: "custom",
                                    label: "Border Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                BorderRadius: {
                                    label: "Border radius",
                                    type: "select",
                                    options: pucksettings['BorderRadius'],
                                },
                            },
                        },
                        Font: {
                            type: "object",
                            objectFields: {
                                fontSize: {
                                    label: "Field font size",
                                    type: "select",
                                    options: pucksettings['fontsizes'],

                                },
                                fontWeight: {
                                    label: "Field font weight",
                                    type: "select",
                                    options: pucksettings['fontweight'],
                                },
                                Color: {
                                    type: "custom",
                                    label: "Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                            },
                        },
                        Margin: {
                            type: "object",
                            objectFields: {
                                top: {
                                    label: "Top",
                                    type: "number",
                                },

                                bottom: {
                                    label: "Bottom",
                                    type: "number",
                                },
                                left: {
                                    label: "Left",
                                    type: "number",
                                },
                                right: {
                                    label: "Right",
                                    type: "number",
                                },
                            },
                        },
                    },
                },

            },
            defaultProps: {
                uuid: "", // default uuid for custom button
                buttonText: "Button",
                buttonAction: "",
                buttonAlignment: "left",
                popupTargetId: "", // 
                PageList: "",
                buttonLink: "https://www.google.com",
                buttonStyle: "primary",
                spacing: 20,
                buttonicon: "yes",
                iconPosition: "right",
                customStyle: false,
                Style: {
                    BackgroundColor: "#fff",
                    Padding: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    },
                    Margin: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    },

                    Font: {
                        fontSize: "fs-15",
                        fontWeight: "fw-700",
                        Color: "#000",

                    },
                    Border: {
                        BorderStyle: "solid",
                        BorderWidth: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        },
                        BorderRadius: 0,
                        BorderColor: "#dedede"
                    },
                }
            },
            render: ({ buttonText, conditionalLogic, buttonAction, PageList, popupTargetId, buttonLink, iconPosition, buttonStyle, buttonicon, iconsize, hide, customStyle, Style, spacing, buttonAlignment }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                // Prepare conditional attributes for the Bootstrap modal
                const modalTriggerAttributes = {};
                if (buttonAction === "OpenPopup" && popupTargetId) {
                    modalTriggerAttributes['data-bs-toggle'] = "modal";
                    // Ensure popupTargetId from Puck field doesn't include '#'
                    // Prepend '#' when setting data-bs-target
                    modalTriggerAttributes['data-bs-target'] = `#${popupTargetId.replace(/^#/, '')}`;
                }
                return (

                    <>

                        <div className={`button-wrap text-${buttonAlignment}`} style={{ opacity: inputOpacity }}>

                            {buttonicon === "yes" ?

                                <button
                                    {...modalTriggerAttributes} // <-- SPREAD CONDITIONAL ATTRIBUTES HERE
                                    className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit"

                                    style={

                                        customStyle ?

                                            {

                                                backgroundColor: `${Style?.BackgroundColor}`,

                                                color: `${Style?.Font?.Color}`,

                                                padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,

                                                margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                                borderStyle: Style?.Border?.BorderStyle,

                                                borderColor: Style?.Border?.BorderColor,

                                                borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,

                                                borderRadius: `${Style?.Border.BorderRadius}px`,

                                                gap: `${spacing ? `${spacing}px` : '20px'}`,

                                            }

                                            : {

                                                gap: `${spacing ? `${spacing}px` : '20px'}`,

                                            }

                                    }

                                >

                                    {(() => {

                                        if (iconPosition === "left") {

                                            if (customStyle) {

                                                return (<> <Svg name="arrow-right-icn-roi" /> {buttonText} </>)

                                            }

                                            else {

                                                return (<> <Svg name="arrow-right-icn-roi" />  {buttonText} </>)

                                            }

                                        } else if (iconPosition === "right") {

                                            if (customStyle) {

                                                return (<> {buttonText} <Svg name="arrow-right-icn-roi" />   </>)

                                            }

                                            else {

                                                return (<>  {buttonText} <Svg name="arrow-right-icn-roi" /> </>)

                                            }

                                        }

                                        else {

                                            return (<>  {buttonText} <img src={icon} alt="" className={`btn-icon`} style={

                                                {

                                                    width: `${iconsize?.Width}px`,

                                                    height: `${iconsize?.Height}px`,

                                                }

                                            } /></>)

                                        }

                                    })()}

                                </button>

                                :

                                <button {...modalTriggerAttributes} className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit" style={

                                    customStyle ?

                                        {

                                            backgroundColor: `${Style?.BackgroundColor}`,

                                            color: `${Style?.Font?.Color}`,

                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,

                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                            borderStyle: Style?.Border?.BorderStyle,

                                            borderColor: Style?.Border?.BorderColor,

                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,

                                            borderRadius: `${Style?.Border.BorderRadius}px`,

                                        }

                                        : {}

                                }>{buttonText}</button>

                            }

                        </div>

                    </>

                )


            },
        },

        //Bootstrap modal component
        // Inside your config.js, for the BootstrapModal component:
        BootstrapModal: {
            fields: {
                modalId: {
                    type: "text",
                    label: "Modal ID (unique, e.g., 'contactModal')",
                },

                // This field is purely for the editor experience
                _editorPreviewContent: { // Prefix with _ to indicate it's an editor-only helper
                    type: "radio", // radio or "toggle" if your Puck version supports it
                    label: "Editor: Preview Modal Content on Canvas",
                    options: [
                        { label: "Show", value: true },
                        { label: "Hide", value: false },
                    ],
                    default: false, // Default to hidden to avoid obstruction
                },
                // You can re-add modalSize, modalShowFooter, modalCloseButtonText if ROIPage.js needs them
                // from this config. Example:
                modalSize: {
                    type: "select",
                    label: "Modal Size (for frontend)",
                    options: [
                        { label: "Default", value: "" },
                        { label: "Small", value: "modal-sm" },
                        { label: "Large", value: "modal-lg" },
                        { label: "Extra Large", value: "modal-xl" },
                    ],
                },
            },
            defaultProps: {
                modalId: "myModal",

                _editorPreviewContent: false, // Content preview hidden by default
                modalSize: "",
                // Children are implicitly handled
            },
            render: ({ modalId, _editorPreviewContent, children, modalSize }) => {
                // This render function is for the Puck admin editor experience.
                return (
                    <>
                        <div style={{
                            padding: '15px',
                            border: `2px ${_editorPreviewContent ? 'solid' : 'dashed'} ${_editorPreviewContent ? '#007bff' : '#6c757d'}`,
                            margin: '10px 0',
                            backgroundColor: _editorPreviewContent ? '#e7f3ff' : '#f8f9fa',
                            borderRadius: '4px',
                            minHeight: _editorPreviewContent ? '150px' : '80px', // Taller when showing content
                            display: 'block',
                            opacity: 1,
                            position: 'relative',
                            // overflow: _editorPreviewContent ? 'visible' : 'hidden', // Control overflow based on preview state
                        }}>


                            {_editorPreviewContent && (
                                <div class="modal position-static d-block" tabindex="-1">
                                    <div class={`modal-dialog p-0 tco-modal-dialog ${modalSize}`}>
                                        <div class="modal-content">
                                            <div class="modal-body modal-body-roi-landing-form">
                                                <DropZone zone="wrapper" />
                                                <form>
                                                    {/* <div className="form-group position-relative mb-30">
                                                        <input type="text" className="form-control" id="org-name" placeholder="Organisation name " />
                                                        <div className="icon-wrapper position-absolute top-50 translate-middle-y">
                                                            <Svg name="org-icn-roi" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group position-relative mb-20">
                                                        <input type="email" className="form-control" id="text" placeholder="Enter email address " />
                                                        <div className="icon-wrapper position-absolute top-50 translate-middle-y">
                                                            <Svg name="email-icn-roi" />
                                                        </div>
                                                    </div>

                                                    <div className="mb-40    form-check ps-0">
                                                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                        <label className="form-check-label" htmlFor="exampleCheck1">I agree to the <a href="https://www.google.com" className="text-decoration-underline color-inherit" _target="blank">terms and privacy policy</a>.</label>
                                                    </div>
                                                    <div className="d-flex justify-content-center">
                                                        <button type="submit" className="d-inline-flex align-items-center btn roi-btn-primary gap-4" >Continue <Svg name="arrow-right-icn-roi" /></button>
                                                    </div> */}


                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}

                            {!_editorPreviewContent && (

                                <p style={{ margin: '0' }}><em>Content preview is hidden. Use the "Editor: Preview Modal Content" toggle in the fields panel or the Outline to manage children.</em></p>

                            )}
                        </div>
                    </>
                )

            },
        },

        ProgressBar: {
            fields: {
                value: {
                    type: "number",
                    label: "Current Value",
                },
                minValue: {
                    type: "number",
                    label: "Minimum Value",
                },
                maxValue: {
                    type: "number",
                    label: "Maximum Value",
                },
                barColor: {
                    type: "text",
                    label: "Bar Color",
                },
                height: {
                    type: "number", // Changed to number
                    label: "Height", // Updated label
                },
                ariaLabel: {
                    type: "text",
                    label: "ARIA Label",
                }
            },
            defaultProps: {
                value: 25,
                minValue: 0,
                maxValue: 100,
                barColor: "#0d6efd",
                height: 16, // Default height as a number (e.g., 16px which is Bootstrap's 1rem default)
                ariaLabel: "Progress bar"
            },
            render: ({ value, minValue, maxValue, barColor, height, ariaLabel, puck }) => {
                const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
                const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

                const progressBarStyle = {
                    width: `${clampedPercentage}%`,
                };
                if (barColor) {
                    progressBarStyle.backgroundColor = barColor;
                }

                const progressContainerStyle = {};
                if (typeof height === 'number') { // Check if height is a number
                    progressContainerStyle.height = `${height}px`; // Append 'px'
                }

                return (
                    <div
                        className="progress roi-progress-bar"
                        role="progressbar"
                        aria-label={ariaLabel || "Progress bar"}
                        aria-valuenow={value}
                        aria-valuemin={minValue}
                        aria-valuemax={maxValue}
                        style={progressContainerStyle}
                    >
                        <div
                            className="progress-bar"
                            style={progressBarStyle}
                        >
                            {/* Label is removed */}
                        </div>
                    </div>
                );
            },
        },

        //Report
        ReportPage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "How much could you save with VBUC?",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">

                                <div className="section-heading mb-3 mb-md-4">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>

                                <div className="stats-section">
                                    <div className="report-accordion-wrapper report-pg-table mb-3 mb-md-4">
                                        <DropZone zone="table-wrapper" />
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-9">
                                            <DropZone zone="card-wrapper" />
                                        </div>

                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <DropZone zone="total-wrapper" />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-8 col-md-12 mb-3">
                                            <DropZone zone="chart-wrapper" />
                                        </div>
                                        <div className="col-lg-4 col-md-12 mb-3">
                                            <DropZone zone="download-wrapper" />

                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>


                    </>
                )

            },
        },

        CardSection: {
            fields: {
                items: {
                    type: "array",
                    label: "Card Sections",
                    arrayFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        Title: { type: "text" },
                        ValueTitle1: { type: "text" },
                        Value1: { type: "text" },
                        ValueTitle2: { type: "text" },
                        Value2: { type: "text" },

                        ActionText: { type: "text" },
                        Action: {
                            type: "select",
                            label: "Choose action",
                            options: [
                                { label: "Open Page", value: "action-1" },
                                { label: "Open Popup", value: "action-2" },
                            ],

                        },
                    },
                    getItemSummary: (item) => item.Title || "Card",
                    defaultItemProps: {
                        Title: "Card title",
                        ValueTitle1: "Microsoft",
                        Value1: "",
                        ValueTitle2: "VBUC",
                        Value2: "",

                        ActionText: "Action",
                        icon: CardIcon
                    },

                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                Text: {
                    type: "object",
                    objectFields: {

                        titleFont: {
                            label: "Title font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Title font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },
                        ValueTitleFont: {
                            label: "Inner title font",
                            type: "select",
                            options: pucksettings['fontsizes'],
                        },
                        ValueTitleWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },
                        ValueFont: {
                            label: "Inner value font",
                            type: "select",
                            options: pucksettings['fontsizes'],
                        },
                        ValueWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },


                    },
                },

            },
            defaultProps: {
                Text: {
                    titleFont: "fs-20",
                    fontWeight: "fw-700",
                    ValueTitleFont: "fs-16",
                    ValueTitleWeight: "fw-700",
                    ValueFont: "fs-28",
                    ValueFontWeight: "fw-300",
                },
                items: [
                    {
                        uuid: "",
                        Title: "Lower Costs",
                        ValueTitle1: "Microsoft Cost",
                        Value1: "£288,342",
                        Value1uuid: "",
                        ValueTitle2: "VBUC Cost",
                        Value2: "£118,314",
                        Value2uuid: "",
                        ValueTitle3: "Microsoft Cost Savings",
                        Value3: "£118,314",
                        Value3uuid: "",
                        ValueTitle4: "VBUC Cost Savings",
                        Value4: "£118,314",
                        Value4uuid: "",
                        ActionText: "Explore and Adjust",
                        buttonValue: "",
                        buttonAction: "OpenPopup",
                        icon: CardIcon
                    },
                    {
                        uuid: "",
                        Title: "Increase Productivity",
                        ValueTitle1: "Microsoft Cost",
                        Value1: "£288,342",
                        Value1uuid: "",
                        ValueTitle2: "VBUC Cost",
                        Value2: "£118,314",
                        Value2uuid: "",
                        ValueTitle3: "Microsoft Cost Savings",
                        Value3: "£118,314",
                        Value3uuid: "",
                        ValueTitle4: "VBUC Cost Savings",
                        Value4: "£118,314",
                        Value4uuid: "",
                        ActionText: "Explore and Adjust",
                        buttonValue: "",
                        buttonAction: "OpenPopup",
                        icon: CardIcon
                    },
                    {
                        uuid: "",
                        Title: "Enable Business",
                        ValueTitle1: "Microsoft Cost",
                        Value1: "£288,342",
                        Value1uuid: "",
                        ValueTitle2: "VBUC Cost",
                        Value2: "£118,314",
                        Value2uuid: "",
                        ValueTitle3: "Microsoft Cost Savings",
                        Value3: "£118,314",
                        Value3uuid: "",
                        ValueTitle4: "VBUC Cost Savings",
                        Value4: "£118,314",
                        Value4uuid: "",
                        ActionText: "Explore and Adjust",
                        buttonValue: "",
                        buttonAction: "OpenPopup",
                        icon: CardIcon
                    },
                ],


            },
            render: ({ items, hide, Text }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="row" style={{ opacity: inputOpacity }}>
                            {items.map((item, i) => (
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <div className="stat-wrap">
                                        <div className="stat-heading">
                                            <div className="icon">
                                                <img src={resolveMediaUrl(item.icon)} alt="" />
                                            </div>
                                            <div className={`text ${Text.titleFont} ${Text.fontWeight}`}>{item.Title}</div>
                                        </div>
                                        <div className="stat-content-wrapper d-flex flex-column">
                                            <div className="d-flex flex-column flex-grow-1">
                                                <div className="value-section value-section-1 d-flex align-items-center">
                                                    <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle1}</div>
                                                    <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                        {item.Value1}
                                                    </div>
                                                </div>
                                                <div className="value-section value-section-2 d-flex align-items-center">
                                                    <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle2}</div>
                                                    <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                        {item.Value2}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="action">
                                                <a href="" className='fs-16 fw-700'>{item.ActionText} <span className="icon">
                                                    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                        <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            },
        },

        ResultCard: {
            fields: {
                Card1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        value: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                Card2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        value: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Card1: {
                    uuid: "",
                    title: "Total First Year Subscription",
                    value: "£802, 850",
                },
                Card2: {
                    uuid: "",
                    title: "Total Three Year Subscription",
                    value: "£2,408,551",
                },
            },
            render: ({ Card1, Card2, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                            <div className="total-inner bg-1">
                                <h5 className='fs-16 fw-700'>{Card1.title}</h5>
                                <p className='fs-48 fw-300'>{Card1.value}</p>
                            </div>
                            <div className="total-inner bg-2">
                                <h5 className='fs-16 fw-700'>{Card2.title}</h5>
                                <p className='fs-48 fw-300'>{Card2.value}</p>
                            </div>
                        </div>

                    </>
                )
            },
        },

        ChartCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Chart1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                value: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                value: 100,
                                Color: "#9C2AA0",
                            },

                        },

                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: pucksettings['chartType'],


                        },
                    },
                },
                Chart2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                value: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                value: 100,
                                Color: "#9C2AA0",
                            },

                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: pucksettings['chartType'],


                        },
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                Heading: {
                    title: "Actual Benefits with Vodafone",
                    fontWeight: "fw-700",
                    titleFont: "fs-20",
                    icon: CardIcon
                },

                Chart1: {
                    uuid: "",
                    title: "Total Licence",
                    subtext: "450",
                    chooseChart: "pie",
                    items: [
                        {
                            uuid: "",
                            Text: "Basic",
                            value: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            uuid: "",
                            Text: "Standard",
                            value: 735,
                            Color: "#EB9700",
                        },
                        {
                            uuid: "",
                            Text: "Premium",
                            value: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
                Chart2: {
                    uuid: "",
                    title: "",
                    chooseChart: "bar",
                    items: [
                        {
                            uuid: "",
                            Text: "Remote Workers",
                            value: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            uuid: "",
                            Text: "Office Workers",
                            value: 735,
                            Color: "#EB9700",
                        },
                        {
                            uuid: "",
                            Text: "On the Road Workers",
                            value: 580,
                            Color: "#00B0CA",
                        },
                        {
                            uuid: "",
                            Text: "Hybrid Workers",
                            value: 580,
                            Color: "#00B0CA",
                        }

                    ]
                },
            },
            render: ({ Chart1, Chart2, Heading, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                // return (
                //     <>
                //         <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                //             <div className="stat-heading">
                //                 <div className="icon d-none">
                //                     <img src={resolveMediaUrl(Heading.icon)} alt="" />
                //                 </div>
                //                 <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>

                //                 <div className="switch-btn">
                //                     <ul className="nav nav-tabs" id="myTab" role="tablist">
                //                         <li className="nav-item" role="presentation">
                //                             <button className="nav-link active" id="tab-1-tab" data-bs-toggle="tab" data-bs-target="#tab-1-tab-pane" type="button"
                //                                 role="tab" aria-controls="tab-1-tab-pane" aria-selected="true">{Chart1.title}</button>
                //                         </li>
                //                         <li className="nav-item" role="presentation">
                //                             <button className="nav-link" id="tab-2-tab" data-bs-toggle="tab" data-bs-target="#tab-2-tab-pane" type="button"
                //                                 role="tab" aria-controls="tab-2-tab-pane" aria-selected="false">{Chart2.title}</button>
                //                         </li>
                //                     </ul>
                //                 </div>
                //             </div>

                //             <div className="stat-content-wrapper">
                //                 <div className="tab-content" id="myTabContent">
                //                     <div className="tab-pane fade show active" id="tab-1-tab-pane" role="tabpanel" aria-labelledby="tab-1-tab" tabIndex={0}>
                //                         {Chart1.chooseChart === "pie" ? <ReactEcharts style={chartStyle} option={OneYearChartOptions} /> : <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} />}
                //                     </div>
                //                     <div className="tab-pane fade" id="tab-2-tab-pane" role="tabpanel" aria-labelledby="tab-2-tab" tabIndex={0}>
                //                         {Chart2.chooseChart === "bar" ? <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} /> : <ReactEcharts style={chartStyle} option={OneYearChartOptions} />}
                //                     </div>
                //                 </div>
                //             </div>
                //         </div>
                //     </>
                // )

                return (
                    <>
                        <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                            <div className="stat-heading">
                                <div className="icon d-none">
                                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                                </div>
                                <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>

                                <div className="switch-btn">
                                    <div className='switch-nav'>
                                        <input
                                            id="microsoft"
                                            type="radio"
                                            name="company"
                                            value="microsoft"
                                        />
                                        <label htmlFor='microsoft'>Microsoft</label>

                                        <input
                                            id='vbuc'
                                            type="radio"
                                            name="company"
                                            value="vbuc"
                                        />
                                        <label htmlFor='vbuc'>VBUC
                                        </label>
                                    </div>

                                    <div className='switch-nav'>


                                        <input
                                            id="year1"
                                            type="radio"
                                            name="year"
                                            value="year1"
                                        />
                                        <label htmlFor='year1'> First Year</label>

                                        <input
                                            id='year3'
                                            type="radio"
                                            name="year"
                                            value="year3"
                                        />
                                        <label htmlFor='year3'>Three Years </label>
                                    </div>
                                </div>
                            </div>

                            <div className="stat-content-wrapper pt-4">

                                <ReactEcharts style={chartStyle} option={PieChartOptions} />

                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },
                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: pucksettings['ButtonStyle'],

                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: pucksettings['buttonIcon'],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },



                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                               
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                </div>

                            </label> */}

                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Savings report",
                    fontWeight: "fw-700",
                    titleFont: "fs-30",
                    Color: "#000000",
                },

                Padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Button: {
                    uuid: "",
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },

                image: "https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png",

            },
            render: ({ Heading, Padding, Button, image, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`save-report-section h-100 d-flex align-items-end`}
                            style={{
                                backgroundImage: `url("${resolveMediaUrl(image)}")`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                opacity: inputOpacity,
                                padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                            }}
                        >

                            <div className="text-wrapper">
                                <h4 className={`${Heading.fontWeight} ${Heading.titleFont}`}
                                    style={{
                                        color: Heading.Color
                                    }}
                                >{Heading.title}</h4>

                                <div class="button-wrap">

                                    {Button.buttonicon === "yes" ?
                                        <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                            <div className="icon">
                                                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </button>
                                        :
                                        <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Report Single page


        ReportSection: {

            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],
                        },
                    },

                },
                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                        Link: { type: "text" },
                        isActive: {
                            type: "custom",
                            label: "Is Active?",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                id={name}
                                                name="isActive"
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Lower Costs",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "Access all of the numbers behind the Lower Costs calculations, with the opportunity to change some numbers.",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },
                items: [
                    {
                        uuid: "",
                        Title: "Cost of Phone Provisioning",
                        isActive: false
                    },
                    {
                        uuid: "",
                        Title: "Downtime",
                        isActive: false
                    },
                    {
                        uuid: "",
                        Title: "IT Integrations",
                        isActive: false
                    },
                    {
                        uuid: "",
                        Title: "Security and Compliance",
                        isActive: false
                    },
                    {
                        uuid: "",
                        Title: "Employee Retention and Engagement",
                        isActive: false
                    },
                ]
            },
            render: ({ Heading, Description, Padding, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">
                                <DropZone zone={`summary-heading`} />
                                <div className="row">
                                    <div className="col-lg-3">
                                        <DropZone zone={`summary-details`} />
                                    </div>
                                    <div className="col-lg-9">
                                        <div className="report-accordion-wrapper">
                                            <ul className="nav nav-tabs" id="myTab" role="tablist">

                                                {items.map((item, i) => (
                                                    <li className="nav-item" role="presentation" key={i}>
                                                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                                        <button className={item.isActive == true ? 'nav-link active' : 'nav-link'}>{item.Title}</button>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="form-wrapper">
                                                {/* <div className="tab-content" id="myTabContent"> */}
                                                {/* {items.map((item, i) => ( */}
                                                {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                                                <div className="form-inner">
                                                    <DropZone zone={`wizard-form-wrapper`} disallow={["SinglePage", "WizardForm"]} />
                                                </div>
                                                {/* </div> */}
                                                {/* ))} */}
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>

                    </>
                )

            },
        },

        ReportTable: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },
                Table: {
                    type: "object",
                    objectFields: {

                        Columns: {
                            type: "number",
                            label: "Columns per Row",
                        },

                        FirstRow: {
                            type: "custom",
                            label: "First Row as Heading",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        LastRow: {
                            type: "custom",
                            label: "Last Row as Result",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                ColumnSettings: {
                    type: "object",
                    objectFields: {
                        FirstColSpan: {
                            type: "text",
                            label: "1st column width",
                        },
                        SecondColSpan: {
                            type: "text",
                            label: "2nd Column width",
                        },
                        ThirdColSpan: {
                            type: "text",
                            label: "3rd Column width",
                        },
                        FourthColSpan: {
                            type: "text",
                            label: "4th Column width",
                        },

                        HighlightCol: {
                            type: 'select',
                            label: 'Highlight Column',
                            options: pucksettings['heightlightColumn'],
                        }
                    },

                },


                Headings: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Cell 1",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Cell 2",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Cell 3",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Cell 4",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },

                items: {
                    type: "array",
                    label: "Rows",
                    arrayFields: {
                        Cell1Data: {
                            type: "custom",
                            label: "Cell 1 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Cell1isEditable: {
                            type: "custom",
                            label: "Cell 1 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        Cell2Data: {
                            type: "custom",
                            label: "Cell 2 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },

                        Cell2isEditable: {
                            type: "custom",
                            label: "Cell 2 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),

                        },

                        Cell2EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],

                        },


                        Cell3Data: {
                            type: "custom",
                            label: "Cell 3 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3isEditable: {
                            type: "custom",
                            label: "Cell 3 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell3EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],

                        },
                        Cell4Data: {
                            type: "custom",
                            label: "Cell 4 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },
                        Cell4isEditable: {
                            type: "custom",
                            label: "Cell 4 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell4EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],

                        },
                    },
                    getItemSummary: (item) => item.Cell1Data || "Row",
                    defaultItemProps: {
                        Title: "Row",
                        Cell1Data: "Text here",
                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",
                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",
                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",

                    },

                },

                Calculations: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Reducing Communications Downtime",
                },
                Table: {
                    Rows: 4,
                    Columns: 4,
                    FirstRow: true,
                    LastRow: false,
                },
                ColumnSettings: {
                    FirstColSpan: '',
                    SecondColSpan: '135',
                    ThirdColSpan: '150',
                    FourthColSpan: '210',
                    HighlightCol: "3rd",
                },
                Headings: {
                    Cell1: "",
                    Cell2: "Current",
                    Cell3: "With Vodafone",
                    Cell4: "Saving with Vodafone",
                },
                items: [
                    {
                        Cell1Data: "Text here",
                        Cell1isEditable: false,

                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",

                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",

                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",
                    },

                ],
                Calculations: {
                    Cell1: "Result",
                    Cell2: "",
                    Cell3: "",
                    Cell4: "",
                },


            },
            render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="accordion-item" style={{ opacity: inputOpacity }}>
                            {Heading?.title && <h2 className="fs-20 fw-700 accordion-button">
                                {Heading.title}
                            </h2>}
                            <div className="accordion-body report-accordion-wrapper">
                                <div className="table-wrapper">
                                    <div className="table-responsive">
                                        <table class="table">
                                            {Table.FirstRow && <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                </tr>
                                            </thead>}

                                            <tbody>
                                                {items.map((item, i) => (
                                                    <tr key={i} className={`${Table.LastRow && `table-last-row`}`}>
                                                        <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                            {item.Cell1isEditable ?
                                                                <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} /> :
                                                                item.Cell1Data
                                                            }
                                                        </td>


                                                        <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell2Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell2Data
                                                                    );
                                                                }

                                                                else if (item.Cell2isEditable && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell2Data
                                                                    );
                                                                }
                                                            })()}

                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell3Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell3Data
                                                                    );
                                                                }

                                                                else if (item.Cell3isEditable && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell3Data
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                            {(() => {
                                                                if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell4Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell4Data
                                                                    );
                                                                }

                                                                else if (item.Cell4isEditable && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell4Data
                                                                    );
                                                                }
                                                            })()}



                                                        </td>
                                                    </tr>
                                                ))}




                                            </tbody>
                                            {/* {Table.LastRow && <tfoot>
                                                <tr>
                                                    <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell1}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell2 ? `£${Calculations.Cell2}` : ""}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell3 ? `£${Calculations.Cell3}` : ""}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell4 ? `£${Calculations.Cell4}` : ""}
                                                    </td>
                                                </tr>
                                            </tfoot>} */}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },


        // Download Report 
        DownloadReportBanner: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                               
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={LogoWhite} className='img-fluid' alt="" />
                                </div>

                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}

                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },


                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                               
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={bannerImageLaptop} className='img-fluid' alt="" />
                                </div>

                            </label> */}

                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },

                backgroundImage: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                              
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={BgImage} className='img-fluid' alt="" />
                                </div>

                            </label> */}

                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],
                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                logo: LogoWhite,
                Heading: {
                    title: "TCO Calculator",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "<p>Explore your Vodafone plan options effortlessly with our Assessment Calculator tool. Simply input your usage details, preferences, and needs, and gain insights into the most suitable plans tailored to you. </p><p>From data allowances to international calls, the Assessment Calculator empowers you to make informed decisions about your telecommunications services. Say goodbye to guesswork and hello to personalized solutions with Vodafone's user-friendly tool, ensuring you get the most out of your mobile experience.</p>",
                    descriptionFont: "fs-20",
                },

                image: bannerImageLaptop,
                backgroundImage: BgImage,

                Padding: {
                    top: "pt-30",
                    bottom: "p3-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Padding, logo, image, backgroundImage, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaUrl(backgroundImage)}")`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="row align-items-center ">
                                        <div className="col-lg-12">
                                            <div className="banner-text">
                                                <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                                <div className="text-part">
                                                    <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },
        DownloadReportPage: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                // onChange={(e) => onChange(e.currentTarget.value)}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {/* <label htmlFor="uploadImage" className='icon-upload'>
                               
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>

                            </label> */}
                            {value ? (<>
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            </>) : (
                                <>
                                    <label htmlFor="uploadImage" className='icon-upload'>

                                        {/* <button className='remove-btn'>
                                                    <Svg name="remove-icn-roi" />
                                                </button> */}
                                        <div className="icon-upload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </label>
                                </>
                            )}

                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],
                        },
                    },

                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "How much could you save with VBUC?",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },

            },
            render: ({ Heading, Description, Padding, logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>

                                    <div className="stats-section">
                                        <div className="row">
                                            <div className="col-lg-12 mb-2">
                                                <DropZone zone="card-wrapper" />
                                            </div>

                                            <div className="col-lg-12 mb-2">
                                                <DropZone zone="total-wrapper" />

                                            </div>

                                            <div className="col-lg-12">
                                                <DropZone zone="chart-wrapper" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadCardSection: {
            fields: {
                items: {
                    type: "array",
                    label: "Card Sections",
                    arrayFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                        ActionText: { type: "text" },
                        Action: {
                            type: "select",
                            label: "Choose action",
                            options: [
                                { label: "Open Page", value: "action-1" },
                                { label: "Open Popup", value: "action-2" },
                            ],

                        },
                    },
                    getItemSummary: (item) => item.Title || "Card",
                    defaultItemProps: {
                        Title: "Card title",
                        Description: "Card description",
                        ActionText: "Action",
                        icon: CardIcon
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    defaultProps: {
                        value: false, // Initially, the dropdown should not be hidden
                    },
                },
            },
            defaultProps: {
                items: [
                    {
                        Title: "Lower Costs",
                        Description: "£288,342",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Increase Productivity",
                        Description: "£18,100",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Enable Business",
                        Description: "£495,900",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                ]

            },
            render: ({ items, hide, Text }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="row gx-2" style={{ opacity: inputOpacity }}>
                            {items.map((item, i) => (
                                <div className="col-lg-4 col-md-4 mb-2">
                                    <div className="stat-wrap">
                                        <div className="stat-heading">
                                            <div className="icon">
                                                <img src={resolveMediaUrl(item.icon)} alt="" />
                                            </div>
                                            <div className={`text ${Text.titleFont} ${Text.fontWeight}`}>{item.Title}</div>
                                        </div>
                                        <div className="stat-content-wrapper d-flex flex-column">
                                            <div className="d-flex flex-column flex-grow-1">
                                                <div className="value-section value-section-1 d-flex align-items-center">
                                                    <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle1}</div>
                                                    <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                        {item.Value1}
                                                    </div>
                                                </div>
                                                <div className="value-section value-section-2 d-flex align-items-center">
                                                    <div className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}>{item.ValueTitle2}</div>
                                                    <div className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}>
                                                        {item.Value2}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="action">
                                                <a href="" className='fs-16 fw-700'>{item.ActionText} <span className="icon">
                                                    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                        <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            },
        },

        DownloadResultCard: {
            fields: {
                Card1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                Card2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Card1: {
                    title: "Total First Year Subscription",
                    description: "£802, 850",
                },
                Card2: {
                    title: "Total Three Year Subscription",
                    description: "£2,408,551",
                },
            },
            render: ({ Card1, Card2, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="total-wrapper row gx-0 flex-row" style={{ opacity: inputOpacity }}>
                            <div className="total-inner bg-1 col-6">
                                <h5 className='fs-16 fw-700 text-center'>{Card1.title}</h5>
                                <p className='fs-48 fw-300 text-center'>{Card1.description}</p>
                            </div>
                            <div className="total-inner bg-2 col-6">
                                <h5 className='fs-16 fw-700 text-center'>{Card2.title}</h5>
                                <p className='fs-48 fw-300 text-center'>{Card2.description}</p>
                            </div>
                        </div>

                    </>
                )
            },
        },

        DownloadChartCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Chart1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },

                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: pucksettings['chartType'],

                        },
                    },
                },
                Chart2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: pucksettings['chartType'],


                        },
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                Heading: {
                    title: "Actual Benefits with Vodafone",
                    fontWeight: "fw-700",
                    titleFont: "fs-20",
                    icon: CardIcon
                },

                Chart1: {
                    uuid: "",
                    title: "First Year",
                    chooseChart: "pie",
                    items: [
                        {
                            uuid: "",
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            uuid: "",
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            uuid: "",
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
                Chart2: {
                    uuid: "",
                    title: "Three Year",
                    chooseChart: "bar",
                    items: [
                        {
                            uuid: "",
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            uuid: "",
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            uuid: "",
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
            },
            render: ({ Chart1, Chart2, Heading, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                            <div className="stat-heading">
                                <div className="icon">
                                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                                </div>
                                <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>


                            </div>

                            <div className="stat-content-wrapper">
                                <div className="tab-content" id="myTabContent">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            {Chart1.chooseChart === "pie" ? <ReactEcharts style={chartStyle} option={OneYearChartOptions} /> : <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} />}
                                        </div>
                                        <div className="col-sm-6">
                                            {Chart2.chooseChart === "bar" ? <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} /> : <ReactEcharts style={chartStyle} option={OneYearChartOptions} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadReportSection: {

            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                name={name}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {value ? (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            ) : (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <div className="icon-upload">
                                        <span>Upload image</span>
                                    </div>
                                </label>
                            )}
                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                    },

                },
                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "Lower Costs",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "Access all of the numbers behind the Lower Costs calculations, with the opportunity to change some numbers.",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },
                items: [
                    { uuid: "", Title: "Cost of Phone Provisioning" },
                    { uuid: "", Title: "Downtime" },
                    { uuid: "", Title: "IT Integrations" },
                    { uuid: "", Title: "Security and Compliance" },
                    { uuid: "", Title: "Employee Retention and Engagement" },
                ]
            },
            render: ({ Heading, Description, Padding, items, logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>

                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>
                                    <div className="report-accordion-wrapper">

                                        <div className="form-wrapper">
                                            <div className="tab-content" id="myTabContent">
                                                {items.map((item, i) => (
                                                    <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>

                                                        <div className="form-inner">
                                                            <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },

        DownloadReportTable: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },
                Table: {
                    type: "object",
                    objectFields: {

                        Columns: {
                            type: "number",
                            label: "Columns per Row",
                        },

                        FirstRow: {
                            type: "custom",
                            label: "First Row as Heading",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        LastRow: {
                            type: "custom",
                            label: "Last Row as Result",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                ColumnSettings: {
                    type: "object",
                    objectFields: {
                        FirstColSpan: {
                            type: "text",
                            label: "1st column width",
                        },
                        SecondColSpan: {
                            type: "text",
                            label: "2nd Column width",
                        },
                        ThirdColSpan: {
                            type: "text",
                            label: "3rd Column width",
                        },
                        FourthColSpan: {
                            type: "text",
                            label: "4th Column width",
                        },

                        HighlightCol: {
                            type: 'select',
                            label: 'Highlight Column',
                            options: pucksettings['heightlightColumn'],
                        }
                    },

                },


                Headings: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Cell 1",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Cell 2",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Cell 3",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Cell 4",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },

                items: {
                    type: "array",
                    label: "Rows",
                    arrayFields: {
                        Cell1Data: {
                            type: "custom",
                            label: "Cell 1 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Cell1isEditable: {
                            type: "custom",
                            label: "Cell 1 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        Cell2Data: {
                            type: "custom",
                            label: "Cell 2 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },

                        Cell2isEditable: {
                            type: "custom",
                            label: "Cell 2 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),

                        },

                        Cell2EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],

                        },


                        Cell3Data: {
                            type: "custom",
                            label: "Cell 3 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3isEditable: {
                            type: "custom",
                            label: "Cell 3 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell3EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],

                        },
                        Cell4Data: {
                            type: "custom",
                            label: "Cell 4 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },
                        Cell4isEditable: {
                            type: "custom",
                            label: "Cell 4 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell4EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: pucksettings['fieldType'],
                        },
                    },
                    getItemSummary: (item) => item.Cell1Data || "Row",
                    defaultItemProps: {
                        Title: "Row",
                        Cell1Data: "Text here",
                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",
                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",
                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",

                    },

                },

                Calculations: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Reducing Communications Downtime",
                },
                Table: {
                    Rows: 4,
                    Columns: 4,
                    FirstRow: true,
                    LastRow: true,
                },
                ColumnSettings: {
                    FirstColSpan: '',
                    SecondColSpan: '135',
                    ThirdColSpan: '150',
                    FourthColSpan: '210',
                    HighlightCol: "3rd",
                },
                Headings: {
                    Cell1: "",
                    Cell2: "Current",
                    Cell3: "With Vodafone",
                    Cell4: "Saving with Vodafone",
                },
                items: [
                    {
                        Cell1Data: "Text here",
                        Cell1isEditable: false,

                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",

                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",

                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",
                    },

                ],
                Calculations: {
                    Cell1: "Result",
                    Cell2: "",
                    Cell3: "",
                    Cell4: "",
                },

            },
            render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="accordion-item" style={{ opacity: inputOpacity }}>
                            <h2 className="fs-14 fw-700 accordion-button">
                                {Heading.title}
                            </h2>
                            <div className="accordion-body">
                                <div className="table-wrapper">
                                    <div className="table-responsive">
                                        <table class="table">
                                            {Table.FirstRow && <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                </tr>
                                            </thead>}

                                            <tbody>
                                                {items.map((item, i) => (
                                                    <tr key={i}>
                                                        <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                            {item.Cell1isEditable ?
                                                                <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} /> :
                                                                item.Cell1Data
                                                            }
                                                        </td>


                                                        <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell2Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell2Data
                                                                    );
                                                                }

                                                                else if (item.Cell2isEditable && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell2Data
                                                                    );
                                                                }
                                                            })()}

                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell3Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell3Data
                                                                    );
                                                                }

                                                                else if (item.Cell3isEditable && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell3Data
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                            {(() => {
                                                                if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell4Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell4Data
                                                                    );
                                                                }

                                                                else if (item.Cell4isEditable && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell4Data
                                                                    );
                                                                }
                                                            })()}



                                                        </td>
                                                    </tr>
                                                ))}




                                            </tbody>
                                            {Table.LastRow && <tfoot>
                                                <tr>
                                                    <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell1}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell2 ? `£${Calculations.Cell2}` : ""}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell3 ? `£${Calculations.Cell3}` : ""}
                                                    </td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>
                                                        {Calculations.Cell4 ? `£${Calculations.Cell4}` : ""}
                                                    </td>
                                                </tr>
                                            </tfoot>}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },


        DownloadReportCardsSection: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                name={name}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {value ? (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            ) : (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <div className="icon-upload">
                                        <span>Upload image</span>
                                    </div>
                                </label>
                            )}
                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },

                Lists: {
                    type: "array",
                    getItemSummary: (item) => item.label || "List",
                    arrayFields: {
                        Image: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        name={name}
                                        onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                    />
                                    {value ? (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <button className='remove-btn' onClick={() => onChange('')}>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                            </div>
                                        </label>
                                    ) : (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <div className="icon-upload">
                                                <span>Upload image</span>
                                            </div>
                                        </label>
                                    )}
                                </>
                            ),
                        },
                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        ButtonText: {
                            type: "custom",
                            label: "Button Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        ButtonLink: {
                            type: "custom",
                            label: "Button link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                    defaultItemProps: {
                        Image: icon,
                        Title: "Medium length section heading goes here",
                        Description: "Lorem ipsum dolor sit amet",
                        ButtonLink: "#",
                        ButtonText: "Button"
                    },
                },

                Settings: {
                    type: "object",
                    objectFields: {

                        TitleFont: {
                            label: "Title font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        TitleFontWeight: {
                            label: "Title font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        TitleColor: {
                            type: "custom",
                            label: "Title Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        DescriptionFont: {
                            label: "Description font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        DescriptionFontWeight: {
                            label: "Description font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        DescriptionColor: {
                            type: "custom",
                            label: "Description Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        ItemsPerRow: {
                            label: "Items per row",
                            type: "select",
                            options: pucksettings['ItemsPerRow'],
                        },

                        ShowIcon: {
                            type: "custom",
                            label: "Show Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        IconPosition: {
                            label: "Image Position",
                            type: "radio",
                            options: [
                                { label: "Top", value: "top" },
                                { label: "Left", value: "left" },
                            ],
                        },

                        ShowButton: {
                            type: "custom",
                            label: "Show Button",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },


                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "Explore these resources for improving productivity and enhancing meeting effectiveness.",
                    fontWeight: "fw-700",
                    titleFont: "fs-22",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },

                Settings: {
                    TitleFont: "fs-20",
                    TitleFontWeight: "fw-700",
                    TitleColor: "#000000",
                    DescriptionFont: "fs-16",
                    DescriptionFontWeight: "fw-400",
                    DescriptionColor: "#000000",
                    ItemsPerRow: '1',
                    ShowIcon: true,
                    IconPosition: "left",
                    ShowButton: true
                },
                Lists: [
                    {
                        Image: icon,
                        Title: "Medium length section heading goes here",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
                        ButtonText: "Explore",
                        ButtonLink: "#"
                    }
                ],

            },
            render: ({ Heading, Description, Padding, logo, Lists, Settings, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>
                                    <div className="report-posts-wrapper">

                                        <div className="list-box-1 d-grid gap-4" style={{ gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`, }}>
                                            {Lists.map((list, i) => (
                                                <div className={`list-box-inner ${Settings.IconPosition === 'left' ? 'd-flex' : ''}`} key={i}>
                                                    {Settings.ShowIcon ? <div className="icon-wrap">
                                                        <img src={resolveMediaUrl(list.Image)} alt="" />
                                                    </div> : ""}

                                                    <div className={`text-wrap flex-grow-1`}>
                                                        <h4 className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`} style={{ color: Settings.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}>{list.Description}</p>
                                                        {Settings.ShowButton
                                                            ? <div className="button-wrap pt-3">
                                                                <a className="link d-inline-flex text-primary fw-700 fs-14 align-items-center" href={list.ButtonLink}>
                                                                    <span>{list.ButtonText}</span> <Svg name="button-arrow" />
                                                                </a>
                                                            </div>
                                                            :
                                                            ""}

                                                    </div>
                                                </div>

                                            ))}


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>
                )

            },
        },

        DownloadReportThankYou: {
            fields: {

                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                name={name}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />
                            {value ? (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            ) : (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <div className="icon-upload">
                                        <span>Upload image</span>
                                    </div>
                                </label>
                            )}
                        </>
                    ),
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                logo: LogoThankYou,
                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc nulla velit, faucibus ut massa a, vulputate euismod leo. Suspendisse potenti. Aenean mollis ",
                    Font: "fs-14",
                },
            },
            render: ({ logo, Description, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className="report-build-wrapper report-thankyou">
                                <div className="logo-wrap">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </div>
                                <div className="desclaimer">
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        // Landing Page components
        TransparentSection: {
            fields: {

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Background: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        name={name}
                                        onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                    />

                                    {value ? (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <button className='remove-btn' onClick={() => onChange('')}>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                            </div>
                                        </label>
                                    ) : (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <div className="icon-upload">
                                                <span>Upload image</span>
                                            </div>
                                        </label>
                                    )}
                                </>
                            ),
                        },
                        Width: {
                            type: "select",
                            label: "Show in",
                            options: pucksettings['containerOptions'],

                        },
                        CustomClass: {
                            type: "text",
                            label: "Custom class",
                        },
                    },
                }


            },
            defaultProps: {
                Style: {
                    Background: "",
                    BackgroundColor: "#fff",
                    Width: "container",
                    CustomClass: "",
                },


                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: false,
                },
            },
            render: ({ Padding, Style }) => {

                return (
                    <>
                        <div className={`component-section ${Style.CustomClass} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${resolveMediaUrl(Style.Background)}")`, backgroundColor: `${Style.BackgroundColor}`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                            {/* <div className='overlay'></div> */}
                            <div className={`${Style.Width} position-relative`}>
                                <DropZone zone="section" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        GradientSection: {
            fields: {

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: pucksettings['padddingTop'],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: pucksettings['padddingBottom'],

                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },
                Style: {
                    type: "object",
                    objectFields: {

                        Width: {
                            type: "select",
                            label: "Show in",
                            options: pucksettings['containerOptions'],
                        },
                    },
                }
            },
            defaultProps: {
                Style: {

                    Width: "container"
                },

                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: false,
                },
            },
            render: ({ Padding, Style }) => {

                return (
                    <>
                        <div className={`component-section gradient-bg ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`}>
                            {/* <div className='overlay'></div> */}
                            <div className={`${Style.Width} position-relative`}>
                                <DropZone zone="section" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        Columns: {
            fields: {
                distribution: {
                    type: "radio",
                    options: [
                        { value: "auto", label: "Auto", },
                        { value: "manual", label: "Manual", },
                    ],
                },
                vertical: {
                    label: "Vertical Align",
                    type: "select",
                    options: pucksettings['VAlign'],
                },
                gap: {
                    label: "Column gap",
                    type: "number",
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Background: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        name={name}
                                        onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                    />

                                    {value ? (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <button className='remove-btn' onClick={() => onChange('')}>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                            </div>
                                        </label>
                                    ) : (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <div className="icon-upload">
                                                <span>Upload image</span>
                                            </div>
                                        </label>
                                    )}
                                </>
                            ),
                        },
                    },
                },
                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },

                        BorderWidth: {
                            type: "object",
                            label: "Border Width",
                            objectFields: {
                                top: {
                                    label: "Top",
                                    type: "number",
                                },

                                bottom: {
                                    label: "Bottom",
                                    type: "number",
                                },
                                left: {
                                    label: "Left",
                                    type: "number",
                                },
                                right: {
                                    label: "Right",
                                    type: "number",
                                },


                            },
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },

                columns: {
                    type: "array",
                    getItemSummary: (col, id) =>
                        `Column ${id + 1}, span ${col.span ? Math.max(Math.min(col.span, 12), 1) : "auto"
                        }`,
                    arrayFields: {
                        span: {
                            label: "Span (1-12)",
                            type: "number",
                            min: 0,
                            max: 12,
                        },
                        backgroundColor: {
                            type: "text",
                            label: "Background color",
                        }
                    },
                },
            },
            defaultProps: {
                distribution: "manual",
                vertical: "align-items-center",
                gap: 20,
                columns: [{}, {}],
                Style: {
                    Background: "",
                    BackgroundColor: "",
                },


                Padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    },
                    BorderRadius: 0,
                    BorderColor: "#dedede"
                },
            },

            render: ({ columns, distribution, vertical, gap, Padding, Style, Border }) => {

                return (
                    <div
                        className={`d-grid section-column ${vertical}`}
                        style={{
                            backgroundImage: `url("${resolveMediaUrl(Style.Background)}")`,
                            backgroundColor: `${Style.BackgroundColor}`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                            borderStyle: Border.BorderStyle,
                            borderColor: Border.BorderColor,
                            borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                            borderRadius: `${Border.BorderRadius}px`,

                            gridTemplateColumns:
                                distribution === "manual"
                                    ? "repeat(12, 1fr)"
                                    : `repeat(${columns.length}, 1fr)`,
                            gridColumnGap: `${gap}px`
                        }}
                    >
                        {columns.map(({ span, backgroundColor }, idx) => (
                            <div
                                key={idx}
                                className="w-100"
                                style={{
                                    display: "flex",
                                    backgroundColor: backgroundColor,
                                    flexDirection: "column",
                                    gridColumn:
                                        span && distribution === "manual"
                                            ? `span ${Math.max(Math.min(span, 12), 1)}`
                                            : "",
                                }}
                            >
                                <DropZone
                                    zone={`column-${idx}`}
                                // disallow={["Section"]}
                                />
                            </div>
                        ))}
                    </div>
                )

            },

        },

        Wrapper: {
            fields: {
                label: {
                    label: "Name (optional)",
                    type: "text",
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Background: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        name={name}
                                        onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                    />

                                    {value ? (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <button className='remove-btn' onClick={() => onChange('')}>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                            </div>
                                        </label>
                                    ) : (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <div className="icon-upload">
                                                <span>Upload image</span>
                                            </div>
                                        </label>
                                    )}
                                </>
                            ),
                        },
                    },
                },

                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: pucksettings['BorderStyle'],

                        },

                        BorderWidth: {
                            type: "object",
                            label: "Border Width",
                            objectFields: {
                                top: {
                                    label: "Top",
                                    type: "number",
                                },

                                bottom: {
                                    label: "Bottom",
                                    type: "number",
                                },
                                left: {
                                    label: "Left",
                                    type: "number",
                                },
                                right: {
                                    label: "Right",
                                    type: "number",
                                },


                            },
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: pucksettings['BorderRadius'],
                        },
                    },
                },
                customClass: {
                    label: "Custom class",
                    type: "text",
                },
            },
            defaultProps: {
                uuid: "",
                label: "",
                Style: {
                    Background: "",
                    BackgroundColor: "",
                },
                customClass: "",
                Padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    },
                    BorderRadius: 0,
                    BorderColor: "#dedede"
                },
            },
            render: ({ Padding, Style, Border, customClass }) => {

                return (
                    <>
                        <div className={`component-wrapper ${customClass}`}
                            style={
                                {
                                    backgroundImage: `url("${resolveMediaUrl(Style.Background)}")`,
                                    backgroundColor: `${Style.BackgroundColor}`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover',
                                    padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                                    borderStyle: Border.BorderStyle,
                                    borderColor: Border.BorderColor,
                                    borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Border.BorderRadius}px`,
                                }
                            }>
                            {/* <div className='overlay'></div> */}
                            <div className={`position-relative`}>
                                <DropZone zone="wrapper" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        Spacing: {
            fields: {
                Height: {
                    label: "Spacing",
                    type: "select",
                    options: pucksettings['spacing'],
                },
            },
            defaultProps: {
                Height: '10px'
            },
            render: ({ Height }) => {

                return (
                    <div style={{ height: `${Height}` }}></div>
                )

            },
        },

        Heading: {
            fields: {
                Text: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        tag: {
                            type: "radio",
                            options: [
                                { label: "h1", value: "h1" },
                                { label: "h2", value: "h2" },
                                { label: "h3", value: "h3" },
                                { label: "h4", value: "h4" },
                                { label: "h5", value: "h5" },
                                { label: "h6", value: "h6" },
                            ],
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
            },
            defaultProps: {
                Text: {
                    title: "Enter title here",
                    titleFont: "fs-16",
                    fontWeight: "fw-700",
                    tag: "h1",
                    Color: "#000000",
                    Align: "left"
                },
                Padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
            },
            render: ({ Text, Padding }) => {

                return (
                    <>
                        {(() => {
                            if (Text.tag === 'h1') {
                                return (
                                    <h1
                                        className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h1>
                                );
                            }
                            else if (Text.tag === 'h2') {
                                return (
                                    <h2
                                        className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h2>
                                );
                            }
                            else if (Text.tag === 'h3') {
                                return (
                                    <h3 className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h3>
                                );
                            }
                            else if (Text.tag === 'h4') {
                                return (
                                    <h4 className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h4>
                                );
                            }
                            else if (Text.tag === 'h5') {
                                return (
                                    <h5 className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h5>
                                );
                            }
                            else if (Text.tag === 'h6') {
                                return (
                                    <h6 className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align,
                                            padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h6>
                                );
                            }
                        })()}

                    </>
                )

            },
        },

        Text: {
            fields: {
                Text: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                        FontSize: {
                            label: "Font size",
                            type: "select",
                            options: pucksettings['fontsizes'],

                        },
                        FontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: pucksettings['fontweight'],
                        },

                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: pucksettings['TextAlign'],
                        },

                    },
                },
            },
            defaultProps: {
                Text: {
                    uuid: "",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
                    FontSize: "fs-16",
                    FontWeight: "fw-400",
                    Color: "#000000",
                    Align: "left",
                }
            },
            render: ({ Text }) => {

                return (
                    <>
                        <div
                            style={{
                                color: `${Text.Color}`,
                                textAlign: Text.Align
                            }}
                            className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`} dangerouslySetInnerHTML={{ __html: Text.text }}>
                        </div>
                    </>
                )

            },
        },

        Image: {
            fields: {
                Image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                name={name}
                                onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                            />

                            {value ? (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <button className='remove-btn' onClick={() => onChange('')}>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                    </div>
                                </label>
                            ) : (
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    <div className="icon-upload">
                                        <span>Upload image</span>
                                    </div>
                                </label>
                            )}
                        </>
                    ),
                },
                fullWidth: {
                    type: "custom",
                    label: "Show full widht",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                AspectRatio: {
                    label: "Aspect Ratio",
                    type: "select",
                    options: pucksettings['imageAspectRatio'],
                },
            },
            defaultProps: {
                uuid: "",
                fullWidth: true,
                Image: bannerImageLaptop,
                AspectRatio: ''
            },
            render: ({ Image, AspectRatio, fullWidth }) => {

                return (
                    <>
                        <div className="image-wrapper">
                            <img src={resolveMediaUrl(Image)} alt="" className={`img-fluid object-cover ${fullWidth && `w-100`} `} style={{ aspectRatio: `${AspectRatio}` }} />
                        </div>
                    </>
                )

            },
        },

        RedCards: {
            fields: {

                Lists: {
                    type: "array",
                    getItemSummary: (list) => list.Title || "List",
                    arrayFields: {

                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className="form-control"
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                    defaultItemProps: {
                        Title: "Subheading one",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    },
                },
                Settings: {
                    type: "object",
                    objectFields: {
                        // conditionalLogic: {
                        //     type: "custom",
                        //     label: "Conditional Logic",
                        //     render: ({ field }) => (
                        //         <>
                        //             <div className="d-flex justify-content-between align-items-center">
                        //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                        //                 <div className="action-switch">
                        //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                        //                         <Svg name="edit-condition" />
                        //                     </button>
                        //                 </div>

                        //             </div>
                        //         </>
                        //     ),
                        // },

                        Border: {
                            type: "object",
                            objectFields: {
                                BorderStyle: {
                                    label: "Border style",
                                    type: "select",
                                    options: pucksettings['BorderStyle'],

                                },
                                BorderWidth: {
                                    label: "Border Width",
                                    type: "select",
                                    options: pucksettings['BorderWidth'],
                                },
                                BorderColor: {
                                    type: "custom",
                                    label: "Border Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                BorderRadius: {
                                    label: "Border radius",
                                    type: "number",

                                },
                            },
                        },
                        Card: {
                            type: "object",
                            objectFields: {
                                Padding: {
                                    type: "object",
                                    objectFields: {
                                        top: {
                                            type: "number"
                                        },
                                        right: {
                                            type: "number"
                                        },
                                        bottom: {
                                            type: "number"
                                        },
                                        left: {
                                            type: "number"
                                        },
                                    }
                                },
                                BackgroundColor: {
                                    type: "custom",
                                    label: "Background color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                UniqueID: {
                                    type: "text",
                                }



                            },
                        },

                        Text: {
                            type: "object",
                            objectFields: {
                                TitleFont: {
                                    label: "Title font size",
                                    type: "select",
                                    options: pucksettings['fontsizes'],
                                },
                                TitleFontWeight: {
                                    label: "Title font weight",
                                    type: "select",
                                    options: pucksettings['fontweight'],
                                },

                                TitleColor: {
                                    type: "custom",
                                    label: "Title Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                DescriptionFont: {
                                    label: "Description font size",
                                    type: "select",
                                    options: pucksettings['fontsizes'],

                                },
                                DescriptionFontWeight: {
                                    label: "Description font weight",
                                    type: "select",
                                    options: pucksettings['fontweight'],
                                },

                                DescriptionColor: {
                                    type: "custom",
                                    label: "Description Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                Align: {
                                    label: "Text align",
                                    type: "select",
                                    options: pucksettings['TextAlign'],
                                },
                            }
                        },

                    },
                },
            },
            defaultProps: {
                Settings: {
                    Border: {
                        BorderStyle: "solid",
                        BorderWidth: 3,
                        BorderRadius: 12,
                        BorderColor: "#e60000"
                    },
                    Card: {
                        Padding: {
                            top: 13,
                            right: 13,
                            bottom: 13,
                            left: 13,
                        },
                        UniqueID: "Section_ID",
                    },
                    Text: {
                        TitleFont: "fs-38",
                        TitleFontWeight: "fw-700",
                        TitleColor: "#fff",
                        DescriptionFont: "fs-20",
                        DescriptionFontWeight: "fw-400",
                        DescriptionColor: "#fff",
                        Align: "center"
                    },

                },
                Lists: [
                    {
                        Title: "Microsoft 365",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    }
                ],
            },
            render: ({ Lists, Settings }) => {

                return (
                    <>
                        <div className="roi-cards-section card-layout-1">
                            <div className="cards-wrapper">
                                <div className="row justify-content-center">
                                    {Lists.map((list, i) => (
                                        <div className="col-lg-4 col-md-6 mb-3"
                                            key={i}>
                                            <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                            <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                borderStyle: Settings.Border.BorderStyle,
                                                borderColor: Settings.Border.BorderColor,
                                                borderWidth: `${Settings.Border.BorderWidth}px`,
                                                borderRadius: `${Settings.Border.BorderRadius}px`,
                                                backgroundColor: Settings.Card.BackgroundColor,
                                                paddingTop: `${Settings.Card.Padding.top}px`,
                                                paddingRight: `${Settings.Card.Padding.right}px`,
                                                paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                paddingLeft: `${Settings.Card.Padding.left}px`,
                                                textAlign: Settings.Text.Align
                                            }}>



                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        WhiteCards: {
            fields: {

                Lists: {
                    type: "array",
                    getItemSummary: (list) => list.Title || "List",
                    arrayFields: {
                        Image: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        name={name}
                                        onChange={(e) => handleImageUpload(e.target.files[0], onChange)}
                                    />

                                    {value ? (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <button className='remove-btn' onClick={() => onChange('')}>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(value)} className='img-fluid' alt="" />
                                            </div>
                                        </label>
                                    ) : (
                                        <label htmlFor="uploadImage" className='icon-upload'>
                                            <div className="icon-upload">
                                                <span>Upload image</span>
                                            </div>
                                        </label>
                                    )}
                                </>
                            ),
                        },
                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className="form-control"
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                    defaultItemProps: {
                        Image: icon2,
                        Title: "Subheading one",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    },
                },
                Settings: {
                    type: "object",
                    objectFields: {
                        // conditionalLogic: {
                        //     type: "custom",
                        //     label: "Conditional Logic",
                        //     render: ({ field }) => (
                        //         <>
                        //             <div className="d-flex justify-content-between align-items-center">
                        //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                        //                 <div className="action-switch">
                        //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                        //                         <Svg name="edit-condition" />
                        //                     </button>
                        //                 </div>

                        //             </div>
                        //         </>
                        //     ),
                        // },

                        Border: {
                            type: "object",
                            objectFields: {
                                BorderStyle: {
                                    label: "Border style",
                                    type: "select",
                                    options: pucksettings['BorderStyle'],
                                },
                                BorderWidth: {
                                    label: "Border Width",
                                    type: "select",
                                    options: pucksettings['BorderWidth'],
                                },
                                BorderColor: {
                                    type: "custom",
                                    label: "Border Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                BorderRadius: {
                                    label: "Border radius",
                                    type: "number",

                                },
                            },
                        },
                        Card: {
                            type: "object",
                            objectFields: {
                                Padding: {
                                    type: "object",
                                    objectFields: {
                                        top: {
                                            type: "number"
                                        },
                                        right: {
                                            type: "number"
                                        },
                                        bottom: {
                                            type: "number"
                                        },
                                        left: {
                                            type: "number"
                                        },
                                    }
                                },
                                BackgroundColor: {
                                    type: "custom",
                                    label: "Background color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                IconSize: {
                                    type: "number",
                                },
                                UniqueID: {
                                    type: "text",
                                }
                            },
                        },

                        Text: {
                            type: "object",
                            objectFields: {
                                TitleFont: {
                                    label: "Title font size",
                                    type: "select",
                                    options: pucksettings['fontsizes'],
                                },
                                TitleFontWeight: {
                                    label: "Title font weight",
                                    type: "select",
                                    options: pucksettings['fontweight'],
                                },

                                TitleColor: {
                                    type: "custom",
                                    label: "Title Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                DescriptionFont: {
                                    label: "Description font size",
                                    type: "select",
                                    options: pucksettings['fontsizes'],
                                },
                                DescriptionFontWeight: {
                                    label: "Description font weight",
                                    type: "select",
                                    options: pucksettings['fontweight'],
                                },

                                DescriptionColor: {
                                    type: "custom",
                                    label: "Description Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                Align: {
                                    label: "Text align",
                                    type: "select",
                                    options: pucksettings['TextAlign'],
                                },
                            }
                        },

                    },
                },
            },
            defaultProps: {
                Settings: {
                    Border: {
                        BorderStyle: "solid",
                        BorderWidth: 1,
                        BorderRadius: 4,
                        BorderColor: "#C1C7CF"
                    },
                    Card: {
                        Padding: {
                            top: 13,
                            right: 13,
                            bottom: 13,
                            left: 13,
                        },
                        UniqueID: "Section_ID2",
                        IconSize: 48,
                    },
                    Text: {
                        TitleFont: "fs-38",
                        TitleFontWeight: "fw-700",
                        TitleColor: "#000",
                        DescriptionFont: "fs-20",
                        DescriptionFontWeight: "fw-400",
                        DescriptionColor: "#000",
                        Align: "center"
                    },

                },
                Lists: [
                    {
                        Image: icon2,
                        Title: "Microsoft 365",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    }
                ],
            },
            render: ({ Lists, Settings }) => {

                return (
                    <>
                        <div className="roi-cards-section card-layout-2">
                            <div className="cards-wrapper">
                                <div className="row justify-content-center">
                                    {Lists.map((list, i) => (
                                        <div className="col-lg-4 col-md-6 mb-3"
                                            key={i}>
                                            <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                            <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                borderStyle: Settings.Border.BorderStyle,
                                                borderColor: Settings.Border.BorderColor,
                                                borderWidth: `${Settings.Border.BorderWidth}px`,
                                                borderRadius: `${Settings.Border.BorderRadius}px`,
                                                backgroundColor: Settings.Card.BackgroundColor,
                                                paddingTop: `${Settings.Card.Padding.top}px`,
                                                paddingRight: `${Settings.Card.Padding.right}px`,
                                                paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                paddingLeft: `${Settings.Card.Padding.left}px`,
                                                textAlign: Settings.Text.Align
                                            }}>

                                                <div className="card-inner">
                                                    {list.Image ? <div class="icon-wrapper">
                                                        <img src={resolveMediaUrl(list.Image)} alt="" height={Settings.Card.IconSize} width={Settings.Card.IconSize} />
                                                    </div> : ""}
                                                    <div className="text-wrapper">
                                                        <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        PieChart: {
            fields: {
                Setup: {
                    type: "object",
                    objectFields: {
                        CustomVariables: {
                            type: "array",
                            label: "Custom Variables",
                            getItemSummary: (item) => item.label || "Custom Variables",
                            arrayFields: {
                                name: {
                                    type: "select",
                                    options: [
                                        { label: "Option 1", value: "Option 1" },
                                        { label: "Option 2", value: "Option 2" },
                                        { label: "Option 3", value: "Option 3" },

                                    ],
                                },

                            },
                            defaultItemProps: {
                                name: "Option 1",
                            },

                        },

                    },
                },

            },
            defaultProps: {
                CustomVariables: [],
                chartOption: {
                    tooltip: {
                        trigger: 'item'
                    },

                    grid: {
                        left: '30%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    series: [{
                        type: "pie",
                        data: [
                            { value: 234, name: "Data 1" },
                            { value: 135, name: "Data 2" },
                            { value: 154, name: "Data 3" }
                        ],
                        top: "0%",
                        radius: ["0%", "100%"]
                    }],

                }
            },
            render: ({ chartOption }) => (
                <>
                    <div className="echart-wrapper">
                        <ReactEcharts
                            style={{
                                height: '200px',
                                width: '100%',
                            }}
                            option={chartOption} />
                    </div>
                </>
            ),
        },

        DoubleBarChart: {
            fields: {},
            defaultProps: {
                chartOption: {
                    tooltip: { trigger: 'axis' },
                    legend: { data: ['Series A', 'Series B'] },
                    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
                    xAxis: [
                        { type: 'category', data: ['Category 1', 'Category 2', 'Category 3', 'Category 4'] }
                    ],
                    yAxis: [{ type: 'value' }],
                    series: [
                        {
                            name: 'DIY Build Cost',
                            type: 'bar',
                            barWidth: 26,
                            barGap: '25%',
                            itemStyle: {
                                borderRadius: [6, 6, 0, 0],
                                color: {
                                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                    colorStops: [
                                        { offset: 0, color: '#FF7A6E' },
                                        { offset: 1, color: '#FF4D4D' }
                                    ]
                                }
                            },
                            emphasis: { itemStyle: { shadowBlur: 8, shadowColor: 'rgba(255,122,110,0.5)' } },
                            data: [1.6, 1.2, 1.5]
                        },
                        {
                            name: 'Partner Cost',
                            type: 'bar',
                            barWidth: 26,
                            itemStyle: {
                                borderRadius: [6, 6, 0, 0],
                                color: {
                                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                    colorStops: [
                                        { offset: 0, color: '#5BA8FF' },
                                        { offset: 1, color: '#2F6BFF' }
                                    ]
                                }
                            },
                            emphasis: { itemStyle: { shadowBlur: 8, shadowColor: 'rgba(91,168,255,0.45)' } },
                            data: [0.9, 0.6, 0.8]
                        }
                    ]
                }
            },
            render: ({ chartOption }) => (
                <>
                    <div className="echart-wrapper">
                        <ReactEcharts
                            style={{
                                height: '240px',
                                width: '100%',
                            }}
                            option={chartOption} />
                    </div>
                </>
            ),
        },

        // Editable double bar chart with full control over title, series names, and values
        DoubleBarChart: {
            fields: {
                Title: {
                    type: "custom",
                    label: "Title aa",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input defaultValue={value} name={name} onChange={(e) => onChange(e.currentTarget.value)} />
                        </>
                    )
                },
                SubTitle: {
                    type: "custom",
                    label: "Sub Title",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input defaultValue={value} name={name} onChange={(e) => onChange(e.currentTarget.value)} />
                        </>
                    )
                },
                SeriesAName: {
                    type: "text",
                    label: "Series A Name",
                },
                SeriesBName: {
                    type: "text",
                    label: "Series B Name",
                },
                Data: {
                    type: "array",
                    label: "Bars (categories & values)",
                    getItemSummary: (item) => item?.Label || "Item",
                    arrayFields: {
                        Label: { type: "text", label: "Category" },
                        A: { type: "text", label: "Series A Value (number)" },
                        B: { type: "text", label: "Series B Value (number)" },
                        SeriesAValueUuid: { type: "text", label: "Series A Input UUID" },
                        SeriesBValueUuid: { type: "text", label: "Series B Input UUID" },
                        LabelUuid: { type: "text", label: "Label UUID" },
                        BUuid: { type: "text", label: "Series B UUID" },
                    },
                    defaultItemProps: {
                        Label: "Year",
                        A: "1.0",
                        B: "0.6",
                        SeriesAValueUuid: "",
                        SeriesBValueUuid: "",
                        LabelUuid: uuidv4(),
                        BUuid: uuidv4(),
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input type="checkbox" defaultChecked={value} name={name} onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    defaultProps: { value: false },
                },
                LegendColor: {
                    type: "text",
                    label: "Legend Text Color",
                },
                LabelColor: {
                    type: "text",
                    label: "Label Text Color",
                },
                TitleColor: {
                    type: "text",
                    label: "Title Text Color",
                },
                SubTitleColor: {
                    type: "text",
                    label: "Subtitle Text Color",
                },
                TooltipTextColor: {
                    type: "text",
                    label: "Tooltip Text Color",
                },
                XAxisLabelColor: {
                    type: "text",
                    label: "X-Axis Label Color",
                },
                YAxisLabelColor: {
                    type: "text",
                    label: "Y-Axis Label Color",
                },
            },
            defaultProps: {
                uuid: "",
                Title: "3-year Projection",
                SubTitle: "(Partner vs DIY)",
                SeriesAName: "DIY Build Cost",
                SeriesBName: "Partner Cost",
                Data: [
                    {
                        Label: "Year 1",
                        A: "1.6",
                        B: "0.9",
                        SeriesAValueUuid: "",
                        SeriesBValueUuid: "",
                    },
                    {
                        Label: "Year 2",
                        A: "1.2",
                        B: "0.6",
                        SeriesAValueUuid: "",
                        SeriesBValueUuid: "",
                    },
                    {
                        Label: "Year 3",
                        A: "1.5",
                        B: "0.8",
                        SeriesAValueUuid: "",
                        SeriesBValueUuid: "",
                    },
                ],
                hide: false,
                LegendColor: "#C9D6EF",
                LabelColor: "#FFFFFF",
                TitleColor: "#E7F0FF",
                SubTitleColor: "rgba(231,240,255,0.7)",
                TooltipTextColor: "#E7F0FF",
                XAxisLabelColor: "#C9D6EF",
                YAxisLabelColor: "#C9D6EF",
            },
            render: ({ Title, SubTitle, SeriesAName, SeriesBName, Data, hide, LegendColor, LabelColor, TitleColor, SubTitleColor, TooltipTextColor, XAxisLabelColor, YAxisLabelColor }) => {
                const inputOpacity = hide ? 0.5 : 1;
                const categories = (Data || []).map(d => d.Label);
                const aData = (Data || []).map(d => parseFloat(d.A || 0));
                const bData = (Data || []).map(d => parseFloat(d.B || 0));

                const formatMillions = (val) => {
                    const num = Number(val);
                    if (!Number.isFinite(num)) return '';
                    return `$${num.toFixed(1)}`;
                };

                const option = {
                    backgroundColor: 'transparent',
                    title: {
                        text: Title,
                        subtext: SubTitle,
                        left: '0',
                        textStyle: { color: TitleColor || '#E7F0FF', fontWeight: 700, fontSize: 16 },
                        subtextStyle: { color: SubTitleColor || 'rgba(231,240,255,0.7)', fontWeight: 400, fontSize: 12 }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' },
                        backgroundColor: 'rgba(16, 24, 40, 0.9)',
                        borderColor: 'rgba(255,255,255,0.08)',
                        textStyle: { color: TooltipTextColor || '#E7F0FF' },
                        formatter: (params) => {
                            if (!params || !params.length) return '';
                            const lines = [params[0].axisValue];
                            params.forEach(p => {
                                const val = Number(p.value);
                                const label = isFinite(val) ? `$${val.toFixed(1)}` : p.value;
                                lines.push(`${p.marker} ${p.seriesName}: ${label}`);
                            });
                            return lines.join('<br/>');
                        }
                    },
                    legend: {
                        top: 8,
                        right: 10,
                        icon: 'rect',
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: { color: LegendColor || '#C9D6EF' },
                        data: [SeriesAName, SeriesBName]
                    },
                    grid: { left: '2%', right: '2%', top: 56, bottom: 36, containLabel: true },
                    xAxis: [{
                        type: 'category',
                        data: categories,
                        axisLine: { lineStyle: { color: '#B6B7B8' } },
                        axisTick: { show: false },
                        axisLabel: { color: XAxisLabelColor || '#C9D6EF' }
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        splitNumber: 8,
                        axisLine: { show: true, lineStyle: { color: '#B6B7B8' } },
                        axisTick: { show: false },
                        axisLabel: { color: YAxisLabelColor || '#C9D6EF', formatter: (val) => `$${Number(val).toFixed(1)}M` },
                        splitLine: { show: false }
                    }],
                    series: [
                        {
                            name: SeriesAName,
                            type: 'bar',
                            barWidth: 26,
                            barGap: '25%',
                            itemStyle: {
                                borderRadius: [6, 6, 0, 0],
                                color: {
                                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                    colorStops: [
                                        { offset: 0, color: '#FF7A6E' },
                                        { offset: 1, color: '#FF4D4D' }
                                    ]
                                }
                            },
                            emphasis: { itemStyle: { shadowBlur: 8, shadowColor: 'rgba(255,122,110,0.5)' } },
                            label: {
                                show: true,
                                position: 'insideTop',
                                formatter: ({ value }) => formatMillions(value),
                                color: LabelColor || '#FFFFFF',
                                fontSize: 14,
                                fontWeight: 700,
                                padding: [0, 0, 6, 0],
                            },
                            data: aData
                        },
                        {
                            name: SeriesBName,
                            type: 'bar',
                            barWidth: 26,
                            itemStyle: {
                                borderRadius: [6, 6, 0, 0],
                                color: {
                                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                    colorStops: [
                                        { offset: 0, color: '#5BA8FF' },
                                        { offset: 1, color: '#2F6BFF' }
                                    ]
                                }
                            },
                            emphasis: { itemStyle: { shadowBlur: 8, shadowColor: 'rgba(91,168,255,0.45)' } },
                            label: {
                                show: true,
                                position: 'insideTop',
                                formatter: ({ value }) => formatMillions(value),
                                color: LabelColor || '#FFFFFF',
                                fontSize: 14,
                                fontWeight: 700,
                                padding: [0, 0, 6, 0],
                            },
                            data: bData
                        }
                    ]
                };

                return (
                    <>
                        <div className="echart-wrapper" style={{ opacity: inputOpacity }}>
                            <ReactEcharts style={{ height: '260px', width: '100%' }} option={option} />
                        </div>
                    </>
                )
            },
        },

        eCharts: {
            fields: {

                Chart: {
                    type: "object",
                    objectFields: {


                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                value: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                value: 100,
                                Color: "#9C2AA0",
                            },

                        },

                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: pucksettings['chartType'],


                        },
                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {


                Chart: {
                    uuid: "",
                    title: "Total Licence",
                    subtext: "0",
                    chooseChart: "pie",
                    items: [
                        {
                            uuid: "",
                            Text: "Basic",
                            value: 0,
                            Color: "#00B0CA",
                        },
                        {
                            uuid: "",
                            Text: "Standard",
                            value: 0,
                            Color: "#EB9700",
                        },
                        {
                            uuid: "",
                            Text: "Premium",
                            value: 0,
                            Color: "#9C2AA0",
                        },

                    ]
                },

            },
            render: ({ Chart, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="echart-wrap" style={{ opacity: inputOpacity }}>

                            {(() => {
                                if (Chart.chooseChart === "pie") {
                                    return <ReactEcharts style={PieChartStyle} option={PieChartOptions} />;
                                } else if (Chart.chooseChart === "bar") {
                                    return <ReactEcharts style={BarChartStyle} option={BarChartOptions} />;
                                }
                            })()}

                        </div>
                    </>
                )
            },
        },

        ToggleSwitch: {
            fields: {

                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                // conditionalLogic: {
                //     type: "custom",
                //     label: "Conditional Logic",
                //     render: ({ field }) => (
                //         <>
                //             <div className="d-flex justify-content-between align-items-center">
                //                 <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                //                 <div className="action-switch">
                //                     <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                //                         <Svg name="edit-condition" />
                //                     </button>
                //                 </div>

                //             </div>
                //         </>
                //     ),
                // },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                Style: {
                    type: "object",
                    objectFields: {

                        Alignment: {
                            label: "Alignment",
                            type: "select",
                            options: pucksettings['HAlign'],
                        },

                        customMargin: {
                            type: "custom",
                            label: "Custom margin",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },
                Margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },


            },
            defaultProps: {
                uuid: "",
                ID: 'ToggleSwitch1',
                items: [
                    {
                        Option: "Option 1",
                        uuid: "",
                    },
                    {
                        Option: "Option 2",
                        uuid: "",
                    }

                ],
                Style: {
                    customMargin: false,
                    Alignment: "",
                },

                Margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                // errorMessage: "Error message",
            },
            render: ({ items, ID, hide, Margin, Style }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-form-group ${Style?.customMargin ? '' : 'mb-3'} position-relative d-flex align-items-center ${Style?.Alignment}`} style={
                            {
                                opacity: inputOpacity,
                                margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                            }}>

                            <div className={`roi-toggle-switch d-flex align-items-center`}
                                style={
                                    {
                                        borderStyle: 'solid',
                                        borderColor: '#B6B7B8',
                                        borderWidth: `1px 1px 1px 1px`,
                                        borderRadius: `4px`
                                    }}>
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.Option}
                                        </label>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </>
                )

            },
        },

        Collapsible: {
            fields: {

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
            },
            defaultProps: {
                uuid: "",
                ID: 'Collapse1',

            },
            render: ({ ID }) => {
                // Calculate opacity based on hide value
                // const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="collapse-header" data-bs-toggle="collapse" href={`#${ID}`} role="button" aria-expanded="false" aria-controls={`${ID}`}>
                            <DropZone zone={`collapse-header`} />
                            <div className="drop-icon">
                                <Svg name="collapsible-icon" />
                            </div>
                        </div>

                        <div className="collapse-body collapse show" id={`${ID}`}>
                            <DropZone zone={`collapse-body`} />
                        </div>
                    </>
                )

            },

        },

        Collapsible2: {
            fields: {
                itemId: {
                    type: "text",
                    label: "Unique ID",
                    // Simple render for itemId, Puck handles the input by default
                },
                headerText: {
                    type: "text",
                    label: "Header Text (Displays on the button)",
                },
            },
            defaultProps: {
                itemId: () => `collapsibleItem-${Math.random().toString(36).substr(2, 9)}`, // More unique default
                headerText: "", // Default to empty, logic below will handle placeholder
            },
            render: ({ itemId, headerText }) => { // Removed 'puck' as we're simplifying editor-specific logic
                const collapseId = `collapse-${itemId}`;
                const headingId = `heading-${itemId}`;

                // Determine the button text
                const displayHeaderText = headerText || "Hide Details";

                // FOR ADMIN EDITOR: Always include "show" to make content area visible
                const collapseClasses = ["accordion-collapse", "collapse", "show"];

                // Button attributes for an "open" state in the editor
                const buttonAttrs = {
                    "className": "accordion-button", // Not "collapsed"
                    "type": "button",
                    "data-bs-toggle": "collapse",   // For Bootstrap semantics
                    "data-bs-target": `#${collapseId}`, // For Bootstrap semantics
                    "aria-expanded": "true",        // Reflects "show" class
                    "aria-controls": collapseId,
                };

                return (
                    <div className="accordion-item details-accordion">
                        <h2 className="accordion-header mb-30" id={headingId}>
                            <button {...buttonAttrs}>
                                {displayHeaderText}
                            </button>
                        </h2>
                        <div
                            id={collapseId}
                            className={collapseClasses.join(" ")}
                            aria-labelledby={headingId}
                        >
                            <div className="accordion-body">
                                <DropZone zone="content" />
                                {/* 
                                    A simple, non-conditional placeholder for the DropZone can be added if desired,
                                    or rely on Puck's default DropZone visual cues.
                                    Example:
                                    <div style={{ 
                                        display: 'none', // Will be hidden if DropZone renders something
                                        padding: '20px', textAlign: 'center', color: '#6c757d', 
                                        border: '1px dashed #ced4da', marginTop: '10px' 
                                    }}>
                                        Drop content here
                                    </div>
                                */}
                            </div>
                        </div>
                    </div>
                );
            },
        },


        IconUploader: {
            fields: {
                iconFile: {
                    type: "custom",
                    label: "Upload Icon",
                    render: ({ name, onChange, value, field }) => {
                        const uniqueInputId = `icon-upload-${name.replace(/\./g, '-')}`;

                        const handleFileChange = async (event) => { // Made async if you add compression later
                            const file = event.target.files[0];
                            if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                    onChange(reader.result);
                                };

                                if (file.type === 'image/svg+xml') {
                                    reader.readAsText(file); // Read SVG as plain text
                                } else {
                                    // For non-SVG images (PNG, JPG, etc.)
                                    // You could add client-side compression here for these types
                                    // before reading as Data URL to reduce payload size.
                                    // Example (requires browser-image-compression library):
                                    /*
                                    try {
                                        const options = {
                                            maxSizeMB: 0.5,
                                            maxWidthOrHeight: 800,
                                            useWebWorker: true,
                                        };
                                        const compressedFile = await imageCompression(file, options);
                                        reader.readAsDataURL(compressedFile);
                                    } catch (error) {
                                        console.error("Image compression error:", error);
                                        reader.readAsDataURL(file); // Fallback to original if compression fails
                                    }
                                    */
                                    reader.readAsDataURL(file); // Read as base64 data URL
                                }
                            } else {
                                onChange("");
                            }
                        };

                        // Helper to prepare src for img tag (handles raw SVG and data URLs)
                        const getDisplaySrc = (imgValue) => {
                            if (typeof imgValue === 'string' && imgValue.trim().startsWith('<svg')) {
                                return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(imgValue)}`;
                            }
                            return imgValue; // Assumes it's already a data URL or external URL
                        };

                        const displayValue = getDisplaySrc(value);

                        return (
                            <>
                                <FieldLabel label={field.label || "Upload Icon"} />
                                <input
                                    type="file"
                                    id={uniqueInputId}
                                    className='d-none'
                                    name={name}
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />

                                {value ? ( // Check original value, not displayValue for existence
                                    <>
                                        <label htmlFor={uniqueInputId} className='icon-upload' style={{ cursor: 'pointer', display: 'inline-block', border: '1px solid #ddd', padding: '5px', borderRadius: '4px', position: 'relative', minWidth: '100px', minHeight: '100px' }}>
                                            <button
                                                type="button"
                                                className='remove-btn'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onChange('');
                                                }}
                                                style={{ position: 'absolute', top: '2px', right: '2px', background: 'rgba(255,255,255,0.7)', border: 'none', borderRadius: '50%', cursor: 'pointer', padding: '2px', zIndex: 1 }}
                                            >
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="img-wrapper" style={{ width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {displayValue && <img src={displayValue} className='img-fluid' alt="Icon Preview" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
                                            </div>
                                        </label>
                                    </>
                                ) : (
                                    <>
                                        <label htmlFor={uniqueInputId} className='icon-upload' style={{ cursor: 'pointer', display: 'inline-block', border: '1px dashed #ccc', padding: '20px', borderRadius: '4px', textAlign: 'center', minWidth: '100px', minHeight: '100px', boxSizing: 'border-box' }}>
                                            <div className="icon-upload-placeholder">
                                                <span>Upload Icon</span>
                                            </div>
                                        </label>
                                    </>
                                )}
                            </>
                        );
                    },
                },
                iconFallbackUrl: {
                    type: "text",
                    label: "Fallback Icon URL (if no upload)",
                },
                iconWidth: {
                    type: "number",
                    label: "Width (px)",
                },
                iconHeight: {
                    type: "number",
                    label: "Height (px)",
                },
            },
            defaultProps: {
                iconFile: "", // Will store raw SVG string or base64 data URL
                iconFallbackUrl: "https://via.placeholder.com/24",
                iconWidth: 24,
                iconHeight: 24,
            },
            render: ({ iconFile, iconFallbackUrl, iconWidth, iconHeight, puck }) => {
                // Helper to prepare src for img tag (handles raw SVG and data URLs)
                const getDisplaySrc = (imgValue) => {
                    if (typeof imgValue === 'string' && imgValue.trim().startsWith('<svg')) {
                        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(imgValue)}`;
                    }
                    return imgValue; // Assumes it's already a data URL or external URL
                };

                const primarySrc = getDisplaySrc(iconFile);
                const fallbackSrc = getDisplaySrc(iconFallbackUrl); // Fallback could also be raw SVG

                const imgSrc = primarySrc || fallbackSrc;
                const displayWidth = iconWidth || 24;
                const displayHeight = iconHeight || 24;

                return (
                    <div>
                        {imgSrc ? (
                            <img
                                src={imgSrc}
                                alt="Icon"
                                style={{
                                    width: `${displayWidth}px`,
                                    height: `${displayHeight}px`,
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    verticalAlign: 'middle',
                                }}
                            />
                        ) : (
                            puck && puck.isEditing && <span style={{ fontSize: '10px', color: '#aaa' }}>No Icon</span>
                        )}
                    </div>
                );
            },
        },

        Separator: {
            fields: {

                color: {
                    label: "Color",
                    type: "text",
                },
                height: {
                    label: "Height",
                    type: "number",
                },
                margin: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },
                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },
                    },
                }
            },
            defaultProps: {

                color: "#000",
                height: 1,
                margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
            },
            render: ({ color, height, margin }) => {
                return (
                    <div className="separator" style={{ backgroundColor: color, height: `${height}px`, margin: `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px` }}>

                    </div>
                )
            },
        },




    },
};

export default config;